"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = true;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "BuilderID";
var cartExtraInfo; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate"; // recharge 2020

var frequency = "";
var recurringchecked = false;
var frequency_unit = ""; //SVG icons

var removeMiniCartTextOrIcon = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">    <path fill-rule="evenodd" clip-rule="evenodd" d="m5.815 7.586 4.188 4.188 1.523-1.523-4.188-4.188 4.189-4.189L10.004.351 5.814 4.54 1.628.352.104 1.875l4.188 4.188-4.188 4.188 1.523 1.523 4.188-4.188z" fill="#1A1B1B"/> </svg>';
var minusIcon = "";
var plusIcon = "";
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  quickCartTotal(); //	window.location.href = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=XXX.myshopify.com";
  //window.location = '/checkout';
});
/*
EVENTS
1. Update quantity
2. remove item from cart
3. reload ajax cart
4. quickCartTotal
5. cart.requestComplete
*/
// Insert <br> after the first two words (skip if title already has <br>).

function formatTitleLineBreak(title) {
  if (!title || title.toLowerCase().indexOf("<br") !== -1) {
    return title;
  }

  var words = String(title).trim().split(/\s+/);

  if (words.length <= 2) {
    return title;
  }

  return words.slice(0, 2).join(" ") + "<br>" + words.slice(2).join(" ");
} // --- Complimentary cap helper ---
// Computes the max allowed qty for a complimentary variant by summing the
// quantities of all parent products that carry _complementary_variant_id
// matching the given complimentary variant ID.
// Works entirely from the /cart.js response — no dependency on cartExtraInfo.


function getComplementaryCap(complementaryVariantId, cartItems) {
  var cap = 0;
  var complementaryIdStr = String(complementaryVariantId);
  console.log("[CAP] Computing cap for complimentary variant:", complementaryIdStr);

  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var itemCompVarId = item.properties ? item.properties["_complementary_variant_id"] : null;

    if (item.properties) {
      console.log("[CAP] Cart item:", item.id, "| _complementary_variant_id:", itemCompVarId, "| _complementary_addon:", item.properties["_complementary_addon"], "| qty:", item.quantity);
    }

    if (itemCompVarId && String(itemCompVarId) === complementaryIdStr) {
      cap += item.quantity;
      console.log("[CAP] → MATCH! Added", item.quantity, "to cap. Running cap:", cap);
    }
  }

  console.log("[CAP] Final cap for", complementaryIdStr, "=", cap);
  return cap;
} // --- Discounted dish cap helper ---
// Same pattern as complimentary: sums parent quantities carrying
// _discounted_dish_variant_id matching the given discounted dish variant.


function getDiscountedDishCap(discountedDishVariantId, cartItems) {
  var cap = 0;
  var dishIdStr = String(discountedDishVariantId);

  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];
    var itemDishVarId = item.properties ? item.properties["_discounted_dish_variant_id"] : null;

    if (itemDishVarId && String(itemDishVarId) === dishIdStr) {
      cap += item.quantity;
    }
  }

  return cap;
} // After any cart change, check all discounted dish items and auto-reduce
// any that exceed their cap. Calls itself recursively until everything
// is within bounds, then invokes the callback.


function enforceDiscountedDishCaps(cart, callback) {
  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];

    if (item.properties && item.properties["_discounted_dish_addon"]) {
      var cap = getDiscountedDishCap(item.id, cart.items);

      if (item.quantity > cap) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: item.key,
            quantity: cap
          },
          dataType: "json",
          success: function success(updatedCart) {
            enforceDiscountedDishCaps(updatedCart, callback);
          },
          error: function error() {
            if (typeof callback === "function") callback(null);
          }
        });
        return;
      }
    }
  } // All discounted dish items are within caps


  if (typeof callback === "function") callback(cart);
} // --- Add-on-only guard ---
// Some products (e.g. the "With Purchase Discounted ... Aerated Dish") are
// only meant to be bought alongside a qualifying product. They are tagged
// `add-on-only` in Shopify — a dedicated tag so this cart rule stays scoped
// to exactly those products (not overloaded with `hide`/`_hidden`, which also
// controls PDP redirects and list/search hiding).
// This returns the line item keys of any add-on-only product currently in the
// cart WITHOUT a qualifying parent, so the caller can remove them.
// A qualifying parent is any cart item whose `custom.discounted_dish` OR
// `custom.complementary_product` metafield points at the add-on's variant
// (exposed as `discounted_dish_variant_id` / `complementary_variant_id` in
// cart.alternate.json).
// `cart` is the /cart.js object (has line keys); `extra` is cartExtraInfo.


function getOrphanAddOnKeys(cart, extra) {
  var keys = [];
  if (!cart || !cart.items || !extra || !extra.items) return keys; // Variant ids that a qualifying parent in the cart legitimizes right now.

  var qualified = {}; // Variant ids that are flagged add-on-only.

  var addOnOnly = {};

  for (var i = 0; i < extra.items.length; i++) {
    var ex = extra.items[i];

    if (ex.discounted_dish_variant_id) {
      qualified[String(ex.discounted_dish_variant_id)] = true;
    }

    if (ex.complementary_variant_id) {
      qualified[String(ex.complementary_variant_id)] = true;
    }

    if (ex.tags && ex.tags.length) {
      for (var t = 0; t < ex.tags.length; t++) {
        if (String(ex.tags[t]).trim().toLowerCase() === "add-on-only") {
          addOnOnly[String(ex.id)] = true;
          break;
        }
      }
    }
  } // Remove any add-on-only line item with no qualifying parent present.


  for (var j = 0; j < cart.items.length; j++) {
    var ci = cart.items[j];
    var vid = String(ci.id); // /cart.js item.id === variant id

    if (addOnOnly[vid] && !qualified[vid]) {
      keys.push(ci.key);
    }
  }

  return keys;
} // After any cart change, check all complimentary items and auto-reduce
// any that exceed their cap.  Calls itself recursively until everything
// is within bounds, then refreshes the UI.


function enforceComplementaryCaps(cart) {
  console.log("[ENFORCE] Running enforceComplementaryCaps. Cart items:", cart.items.length);

  for (var i = 0; i < cart.items.length; i++) {
    var item = cart.items[i];

    if (item.properties && item.properties["_complementary_addon"]) {
      var cap = getComplementaryCap(item.id, cart.items);
      console.log("[ENFORCE] Complimentary item:", item.id, "qty:", item.quantity, "cap:", cap, item.quantity > cap ? "→ EXCEEDS, reducing" : "→ OK");

      if (item.quantity > cap) {
        // Reduce this complimentary to the cap (or remove if cap is 0)
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: item.key,
            quantity: cap
          },
          dataType: "json",
          success: function success(updatedCart) {
            // Re-check in case multiple complimentary items need adjusting
            enforceComplementaryCaps(updatedCart);
          },
          error: function error() {
            getCartData();
          }
        });
        return; // exit — the recursive call will handle the rest
      }
    }
  } // All complimentary items are within their caps — now enforce discounted dish caps


  enforceDiscountedDishCaps(cart, function (finalCart) {
    getCartData(finalCart || cart);
  });
} //QUANTITY UPDATE


var _updateCartDebounceTimers = {};

function updateCartQuantity(cartThis) {
  var id = $(cartThis).attr("data-variant-id");
  var quantity = $("#updates_" + id).val();
  var type = $(cartThis).attr("date-type");
  var newQuantity = parseInt(quantity);

  if (type == "plus") {
    newQuantity = newQuantity + 1;
  } else {
    if (newQuantity > 0) {
      newQuantity = newQuantity - 1;
    }
  } // Update the input immediately for responsiveness.
  // If this is a complimentary item, the post-update enforceComplementaryCaps()
  // will auto-reduce it if it exceeds the parent cap.


  $("#updates_" + id).val(newQuantity); // Per-variant debounce to prevent race conditions from rapid clicks
  // without cancelling updates to different variants

  if (_updateCartDebounceTimers[id]) {
    clearTimeout(_updateCartDebounceTimers[id]);
  }

  _updateCartDebounceTimers[id] = setTimeout(function () {
    delete _updateCartDebounceTimers[id];
    var formData = {
      updates: {}
    };
    formData.updates[id] = newQuantity;
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: formData,
      dataType: "json",
      success: function success(cart) {
        // After any qty change, enforce complimentary caps
        // (handles the case where a parent qty decreased)
        enforceComplementaryCaps(cart);
      },
      error: function error(_error) {
        console.error("Error updating items from the cart:", _error);
      }
    });
  }, 300);
}
/* If you need extra information like collection title, metafield etc then use this function */


function reloadAjaxCartItemUsingCartAjaxObject(data) {
  //   cartInfo(data);
  $.ajax({
    type: "GET",
    url: "/cart?view=alternate.json",
    success: function success(response) {
      //extra information against the cart like collection title metafield, product title metafield, tags
      cartExtraInfo = $.parseJSON(response); // Strip any add-on-only product (e.g. discounted dish) that is in the
      // cart without a qualifying parent before rendering.

      var cartForGuard = data || (typeof CartJS !== "undefined" ? CartJS.cart : null);
      var orphanKeys = getOrphanAddOnKeys(cartForGuard, cartExtraInfo);

      if (orphanKeys.length) {
        removeItemsFromCart(orphanKeys, function () {
          getCartData();
        });
        return;
      }

      cartInfo(data); // Populate addon products

      populateAddonProducts(cartExtraInfo);
    },
    error: function error(status) {
      console.warn("ERROR", status);
      cartInfo(data);
    }
  });
} // Populate addon products in cart drawer and cart page


function populateAddonProducts(cartExtraInfo) {
  if (!cartExtraInfo || !cartExtraInfo.addons || cartExtraInfo.addons.length === 0) {
    $(".js__addon-products-wrapper").html("");
    $(".js__cart-page-addon-wrapper").html("");
    $(".js__cart-page-addon-product").hide();
    $(".js__cart-minicart-addon-product").hide();
    return;
  } // Get array of variant IDs already in cart - convert to string for consistency


  var cartVariantIds = [];

  if (cartExtraInfo.items && cartExtraInfo.items.length > 0) {
    $.each(cartExtraInfo.items, function (index, item) {
      if (item.id) {
        cartVariantIds.push(String(item.id));
      }
    });
  }

  var addonHTML = ""; // For cart drawer (swiper format)

  var cartPageAddonHTML = ""; // For cart page (flex-wrap format)

  var processedAddonIds = []; // Track addon IDs already processed to avoid duplicates

  $.each(cartExtraInfo.addons, function (index, addon) {
    // Skip if this addon is already in the cart - convert to string for consistency
    var addonIdStr = String(addon.id);

    if ($.inArray(addonIdStr, cartVariantIds) !== -1) {
      return true; // continue to next iteration
    } // Skip if this addon ID has already been processed in this iteration


    if ($.inArray(addonIdStr, processedAddonIds) !== -1) {
      return true; // continue to next iteration
    } // Mark this addon as processed


    processedAddonIds.push(addonIdStr);
    var price = formatter.format(addon.variant_price / 100); // HTML for cart drawer (swiper-slide format)

    var addonHTMLItem = '<li class="swiper-slide">';
    addonHTMLItem += '<div class="image-section">';
    addonHTMLItem += '<img src="' + addon.productImage + '" alt="' + addon.product_title + '">';
    addonHTMLItem += "</div>";
    addonHTMLItem += '<div class="content">';
    addonHTMLItem += '<span class="name">' + addon.product_title + "</span>";
    addonHTMLItem += '<span class="price">' + price + "</span>";
    addonHTMLItem += '<a href="javascript:;" class="btn--primary js__addon-add-to-cart" data-attr-variantid="' + addon.id + '">Add</a>';
    addonHTMLItem += "</div>";
    addonHTMLItem += "</li>"; // HTML for cart page (flex format)

    var cartPageItem = '<li class="flex">';
    cartPageItem += '<div class="image-section">';
    cartPageItem += '<img src="' + addon.productImage + '" alt="' + addon.product_title + '">';
    cartPageItem += "</div>";
    cartPageItem += '<div class="content">';
    cartPageItem += '<span class="name">' + addon.product_title + "</span>";
    cartPageItem += '<span class="price">' + price + "</span>";
    cartPageItem += '<a href="javascript:;" class="btn--primary js__addon-add-to-cart" data-attr-variantid="' + addon.id + '">Add</a>';
    cartPageItem += "</div>";
    cartPageItem += "</li>";
    addonHTML += addonHTMLItem;
    cartPageAddonHTML += cartPageItem;
  }); // Populate cart drawer

  $(".js__addon-products-wrapper").html(addonHTML); // Populate cart page

  if (cartPageAddonHTML !== "") {
    $(".js__cart-page-addon-wrapper").html(cartPageAddonHTML);
    $(".js__cart-page-addon-product").show();
    $(".js__cart-minicart-addon-product").show();
  } else {
    $(".js__cart-page-addon-wrapper").html("");
    $(".js__cart-page-addon-product").hide();
    $(".js__cart-minicart-addon-product").hide();
  } // Initialize the swiper if it exists (for cart drawer)


  if (typeof Swiper !== "undefined") {
    /* Hero Banner SLider */
    var addonProducts = new Swiper(".js_addon-products-slider", {
      slidesPerView: 1,
      resistance: false,
      autoHeight: true,
      loop: false,
      // autoplay: {
      //     delay: 10000,
      // },
      // Navigation arrows
      pagination: {
        el: ".swiper-pagination-addon-product",
        clickable: true
      }
    });
  }
} //RELOAD AJAX CART


function cartInfo(data) {
  var lineCount = 1;
  var cartObject;

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".js__ajax-products-bind").removeClass("empty");
  $(".cart-list").html("");

  if (cartObject.items.length == 0) {
    $(".empty-cart-section").show();
    $(".template-cart").find(".four-column-reviews").hide();
    $(".js__show-cart-items-section").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__ajax-products-bind").html("<li>Your Cart is Empty</li>");
    $(".js__ajax-products-bind").addClass("empty");
  } else {
    $(".js__top-cart-form-actions").show();
    $(cartObject.items).each(function () {
      var imageURL = this.featured_image.url; //imageURL = imageURL[0] + "." + imageURL[1] + '_450x450' + "." + imageURL[2];

      var imageAlt = this.featured_image.alt;
      var itemPrice = this.original_price;
      var itemLinePriceTotal = this.line_price;
      var handle = this.handle;
      var itemID = this.id;
      var itemPriceAfterDiscount = this.discounted_price;
      var comparePrice = "";
      var disabled = "";
      var finalLineItemPrice = this.final_line_price;
      var cartBundleBoxID = "";
      var boolPromoOffer = false;
      var productTitle = this.product_title;
      var url = this.url;
      var itemProperties = "";
      var itemPropertiesElement = "";
      var boolItemBoxType = false;
      var hideElementClass = "";
      var readonly = "";
      var justifyCenter = "";
      var sellingPlayInformation = "";
      var isComplementaryItem = false;
      var isDiscountedDishItem = false;

      if (this.selling_plan_allocation != undefined) {
        sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
      }

      if (this.properties != null) {
        itemProperties = this.properties;

        if (Object.keys(itemProperties).length > 0) {
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID) {
              cartBundleBoxID = value;
            }

            if (key == "_ProductUrl") {
              url = value;
            }

            if (key == "_promoOffer") {
              boolPromoOffer = true;
            }

            if (key == "_complementary_addon") {
              isComplementaryItem = true; // Complimentary items now show quantity controls so users can
              // reduce quantity to avoid product wastage.
              // Parent URL is picked up from cartExtraInfo.product_parent_url
              // (not from line item properties, to allow clubbing).
            }

            if (key == "_discounted_dish_addon") {
              isDiscountedDishItem = true;
            } // "Add-on" property is on the main product (e.g. "With Spoon").
            // We no longer hide quantity controls for the main product.

          });
          /* Checking the Box ID for the builder */

          itemPropertiesElement = "<ul>";
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID || key == "_FreeGift") {
              hideElementClass = "hide";
              readonly = "readonly='readonly'";
              boolItemBoxType = true;
              justifyCenter = "justify-center ";
              url = "javascript:;";
            }

            if (key.indexOf("_") > -1) {} else {
              if (key === "Add-on") {
                // Hide all Add-on properties from the cart display (both "With" and "Without" complimentary).
                return;
              } else {
                if (key != boxID) {
                  itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                  itemPropertiesElement += "</li>";
                } else {
                  itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                  itemPropertiesElement += "</li>";
                }
              }
            } // Recharge - when subscription is via properties for older recharge version before November 2020
            // recharge2020(key, value);

          }); // Recharge 2020, check if it's a subscription, then bind the value in the UL

          if (recurringchecked) {
            itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
            itemPropertiesElement += "</li>";
          }

          itemPropertiesElement += "</ul>";
        } else {//itemPropertiesElement = "";
        }
      }

      var rechargeSelected = this.selling_plan_allocation;
      var rechargeDropdown = "";
      /* Loop through cartExtraInformation section */

      $(cartExtraInfo.items).each(function (key, value) {
        if (value.id == itemID) {
          if (value.comparePrice != null) {
            comparePrice = value.comparePrice;
          }

          if (value.productImage != null) {
            imageURL = value.productImage;
          }

          var Quantity = value.quantity;

          if (value.product_recharge == "True") {
            if (rechargeSelected == undefined) {
              rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + Quantity + " class='" + hideElementClass + " custom-dropdown-select js__cart-plan'><option value=" + value.product_rechargeID + ">" + value.product_rechargeName + "</option><option value='One Time Purchase' selected>One Time Purchase</option></select>";
            } else {
              rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + this.quantity + " class='" + hideElementClass + " custom-dropdown-select js__cart-plan'><option value=" + value.product_rechargeID + " selected>" + value.product_rechargeName + "</option><option value='One Time Purchase'>One Time Purchase</option></select>";
            }
          } // If the cart item's underlying product has a custom parent URL metafield,
          // prefer it for the link target (keep javascript:; links disabled).


          if (value.product_parent_url && url !== "javascript:;") {
            url = value.product_parent_url;
          } // Strip the "with <variant>" suffix from parent product titles
          // (e.g. "Body Wash with Lavender" → "Body Wash") so the cart
          // shows the clean product name.
          // Skip the split for complimentary items — their full title
          // must be preserved (e.g. "Spoon with Silicone Grip" stays intact).


          var displayTitle = isComplementaryItem ? value.product_title : value.product_title.split("with")[0];
          displayTitle = formatTitleLineBreak(displayTitle);
          productTitle = "<h5 class'h6'> <a href='" + url + "' id='product-card-" + this.id + "' tabindex='0'>" + displayTitle + " </a></h5>";
        }
      });
      /* get compare price using cartLib object */
      // if (typeof cartLib !== "undefined") {
      //           $.each(cartLib, function(key, value) {
      //               //console.log(value);
      //               if (value["id"] == itemID) {
      //                   comparePrice = value["comparePrice"];
      //               }
      //           });
      //       }

      /* FORMATTED PRICING */

      var formattedcomparePrice = formatter.format(comparePrice / 100);
      var comparePriceHtml = "";

      if (comparePrice > parseFloat(itemPrice)) {
        comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
      } // total compared price for the item with quantity


      var totalListItemComparePrice = formatter.format(comparePrice * this.quantity / 100); // item original price

      var formattedItemPrice = formatter.format(itemPrice / 100); // line price

      var formattedItemLinePriceTotal = formatter.format(itemLinePriceTotal / 100); //final line item price

      var formattedFinalLineItemPrice = formatter.format(finalLineItemPrice / 100); //Price after discount

      var showPrice = "";
      var itemPriceAfterDiscountStatus = false;
      var discountedMessage = "";
      var discountedMessageElement = "";

      if (this.discounts != null) {
        discountedMessage = this.discounts;

        if (Object.keys(discountedMessage).length > 0) {
          //console.log("DISCOUNT EXISTS");
          discountedMessageElement = "<span class='discountedMessage'>";
          $.each(discountedMessage, function (key, value) {
            discountedMessageElement += value.title;
          });
          discountedMessageElement += "</span>";
        }
      }

      var formattedItemPriceAfterDiscount = formatter.format(itemPriceAfterDiscount / 100); // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values

      if (this.discounts.length > 0) {
        itemPriceAfterDiscountStatus = true;
      } // if it's true; then show the compared price as the main price this.price and main price as discounted price


      if (itemPriceAfterDiscountStatus) {
        //comparePriceHtml
        showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
      } else {
        showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
      }
      /* check if variantTitle is NULL, then don't show variant */


      var variantTitle = this.variant_title;

      if (variantTitle == null) {
        variantTitle = "";
      }

      var variantData = "";
      $.each(this.options_with_values, function (key, value) {
        // Strip "with <variant>" suffix from variant option values for
        // parent products only. Complimentary items keep the full value.
        var optionValue = isComplementaryItem ? value["value"] : value["value"].split("with")[0];
        variantData += "<li><span>" + value["name"] + ": " + optionValue + "</span></li>";
      });
      /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
                To be applied for all the products with BoxID and Promo Offer
                */

      if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
        //if you want to hide the quantity + - then enable the class below
        // hideElementClass="hide"
        justifyCenter = "justify-center ";
        readonly = "readonly='readonly'";
        disabled = "disabled ";
      }
      /*
       LINE ITEM FOR THE MINI CART
        */
      // remove anchor
      //quantity element


      var quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" date-type="minus" onclick="updateCartQuantity(this)"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" date-type="plus" onclick="updateCartQuantity(this)"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>"; //vendor element

      var vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
      var lineItem;
      lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + ' data-is-complementary="' + isComplementaryItem + '" data-is-discounted-dish="' + isDiscountedDishItem + '"' + '><div class="image-section"> <a href="' + url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
      lineItem += '<div class="content"><div class="title-section">' + productTitle + "";

      if (sellingPlayInformation != "") {
        lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
      }

      if (itemPropertiesElement != "") {
        lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
      }

      if (variantTitle != "") {
        lineItem += "<ul>" + variantData + "</ul>";
      }

      lineItem += showPrice + '</div><div class="flex-space-between"><div class="quantity-remove-outer">' + quantityElement + "</div>";
      lineItem += "<span class='cart-price'>" + formattedItemPriceAfterDiscount + comparePriceHtml + "</span></div>";
      lineItem += '<a class="remove" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + ' href="javascript:;">remove</a></div>';
      lineItem += "</li>";
      /* Bind the line item to the list */

      $(".js__ajax-products-bind").append(lineItem);
      /*******LINE ITEM FOR THE CART PAGE********/

      if ($(".cart-list")[0]) {
        var cartLineItem = "";
        cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '" data-is-complementary="' + isComplementaryItem + '"' + '"><div class="cart-list__items__columns"><a class="image-section " href="' + url + '"><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></a> <div class="content">'; // show vendor on cart page

        if (showVendorOnCartPage) {
          cartLineItem += vendorElement;
        }

        cartLineItem += productTitle;
        cartLineItem += '<div class="cart-list__variant-properties">';

        if (sellingPlayInformation != "") {
          cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
        }

        if (itemPropertiesElement != "") {
          cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
        }

        if (variantTitle != "") {
          cartLineItem += "<ul>" + variantData + "</ul>";
        }

        cartLineItem += showPrice + "</div>";
        cartLineItem += "</div>  </div> ";
        cartLineItem += '<div class="cart-list__items__columns price" > ' + showPrice; // ** Remove action is added here too

        cartLineItem += "</div>";
        cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '   <span class="js__out-of-stock"></span>'; // ** Remove action is added here too

        cartLineItem += "</div><div class='cart-list__items__columns remove ' ><a class='remove' data-cart-line-count='" + lineCount + "' data-variant-id='" + itemID + "' href='javascript:;'>remove</a></div>";
        cartLineItem += '<div class="cart-list__items__columns total-price " data-head="Total"> <span class="price-wrapper js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + "><s>" + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>"; // ** Remove element is added here too

        cartCountEmptyValue += " </div></div>";
        $(".cart-list").append(cartLineItem);
      }

      lineCount++;
    });
  }
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-sub-total").html(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}
/* REMOVE */


var savedItemPropertyBoxID = "";
$(document).on("click", ".remove", function () {
  var variantID = parseInt($(this).attr("data-variant-id"));
  var clickedLineItemCount = parseInt($(this).attr("data-cart-line-count"));
  var currentLoopItemCount = 1;
  var boxID = "BuilderID";
  var itemKeysToRemove = [];
  $.getJSON("/cart.js", function (cart) {
    var savedItemPropertyBoxID = "";
    var removedItem = null; // Find the clicked item

    for (var i = 0; i < cart.items.length; i++) {
      if (clickedLineItemCount === currentLoopItemCount) {
        var currentItem = cart.items[i];

        if (currentItem.variant_id === variantID) {
          removedItem = currentItem;
          var isComplementaryAddon = currentItem.properties && currentItem.properties["_complementary_addon"];
          var isDiscountedDishAddon = currentItem.properties && currentItem.properties["_discounted_dish_addon"];

          if (isComplementaryAddon || isDiscountedDishAddon) {
            // Removing a complimentary or discounted dish item — just remove it, no cascading
            itemKeysToRemove.push(currentItem.key);
          } else if (currentItem.properties && currentItem.properties[boxID]) {
            savedItemPropertyBoxID = currentItem.properties[boxID];
            break;
          } else {
            // Removing a normal/parent product
            itemKeysToRemove.push(currentItem.key);
          }
        }
      }

      currentLoopItemCount = currentLoopItemCount + 1;
    } // Handle BuilderID grouping (unchanged)


    if (savedItemPropertyBoxID) {
      for (var j = 0; j < cart.items.length; j++) {
        var ci = cart.items[j];

        if (ci.properties && ci.properties[boxID] === savedItemPropertyBoxID) {
          itemKeysToRemove.push(ci.key);
        }
      }
    } // Remove the items first, then enforce complimentary caps.
    // This handles the case where removing a parent product means the
    // complimentary's cap drops and needs to be auto-reduced.


    removeItemsFromCart(itemKeysToRemove, function (lastCart) {
      if (lastCart) {
        enforceComplementaryCaps(lastCart);
      } else {
        getCartData();
      }
    });
  });
}); // Function to remove items from the cart using line item keys.
// Accepts an optional callback(lastCart) invoked after all removals.
// If no callback, falls back to getCartData().

function removeItemsFromCart(itemKeysToRemove, callback) {
  if (!itemKeysToRemove || !itemKeysToRemove.length) {
    if (typeof callback === "function") {
      callback(null);
    }

    return;
  }

  var index = 0;

  function removeNext(lastCart) {
    if (index >= itemKeysToRemove.length) {
      if (typeof callback === "function") {
        callback(lastCart);
      } else if (lastCart) {
        getCartData(lastCart);
      } else {
        getCartData();
      }

      return;
    }

    var key = itemKeysToRemove[index];
    index++;
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: key,
        quantity: 0
      },
      dataType: "json",
      success: function success(cart) {
        removeNext(cart);
      },
      error: function error(_error2) {
        console.error("Error removing item from the cart:", _error2);
        removeNext();
      }
    });
  }

  removeNext();
}

function getCartData() {
  $.getJSON("/cart.js", function (cart) {
    // Fetch the alternate cart JSON first so we can strip any add-on-only
    // product that has no qualifying parent BEFORE rendering the cart.
    $.ajax({
      type: "GET",
      url: "/cart?view=alternate.json",
      success: function success(response) {
        cartExtraInfo = $.parseJSON(response);
        var orphanKeys = getOrphanAddOnKeys(cart, cartExtraInfo);

        if (orphanKeys.length) {
          // Remove the orphaned add-on(s), then re-run from a clean cart.
          removeItemsFromCart(orphanKeys, function () {
            getCartData();
          });
          return;
        }

        cartInfo(cart);
        populateAddonProducts(cartExtraInfo);
      },
      error: function error(status) {
        console.warn("ERROR fetching addon products", status); // Fall back to rendering — guard just can't run without the tags.

        cartInfo(cart);
      }
    });
  });
}
"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

jQuery(function () {
  var _Swiper;

  var productSectionSlider = new Swiper(".js__product-section-slider", {
    slidesPerView: 4,
    spaceBetween: 10,
    // centeredSlides: true,
    // resistance: false,
    loop: true,
    resistance: false,
    shortSwipes: true,
    longSwipes: false,
    // scrollOverflowOptions: null,
    // loopedSlidesLimit: false,
    navigation: {
      nextEl: ".swiper-button-next-product-section",
      prevEl: ".swiper-button-prev-product-section"
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      376: {
        slidesPerView: 1
      },
      481: {
        slidesPerView: 1
      },
      769: {
        slidesPerView: 3
      },
      1100: {
        slidesPerView: 4
      }
    }
  });
  var swiper = new Swiper(".js_three-column-product-slider", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".swiper-button-next-three-column",
      prevEl: ".swiper-button-prev-three-column"
    },
    breakpoints: {
      601: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 30
      },
      981: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 30
      }
    }
  });
  var addonProducts = new Swiper(".js_addon-products-slider-pdp", {
    slidesPerView: 1,
    resistance: false,
    autoHeight: true,
    loop: false,
    // autoplay: {
    //     delay: 10000,
    // },
    // Navigation arrows
    pagination: {
      el: ".swiper-pagination-addon-product-pdp",
      clickable: true
    }
  });
  /* Hero Banner SLider */

  var heroSlider = new Swiper(".js__hero-banner-slider", {
    slidesPerView: 1,
    resistance: false,
    loop: false,
    // autoplay: {
    //     delay: 10000,
    // },
    // Navigation arrows
    pagination: {
      el: ".swiper-pagination-herobanner",
      clickable: true
    }
  });
  var marquee = document.querySelectorAll(".js_logo-slider .swiper-wrapper .swiper-slide");

  if (marquee.length > 0) {
    var wrapper = document.querySelector(".js_logo-slider .swiper-wrapper");

    for (var i = 0; i < 500; i++) {
      marquee.forEach(function (slide) {
        // Clone each slide
        var clone1 = slide.cloneNode(true); // Inject it into the wrapper

        wrapper.appendChild(clone1);
      });
    }
  } // logo Slider


  var logoSlider = new Swiper(".js_logo-slider", (_Swiper = {
    // slidesPerView: "auto",
    spaceBetween: 0,
    watchSlidesProgress: true,
    clickable: true,
    resistance: false,
    shortSwipes: false,
    freeMode: true,
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    },
    slidesPerView: 5.5
  }, _defineProperty(_Swiper, "spaceBetween", 100), _defineProperty(_Swiper, "speed", 4000), _defineProperty(_Swiper, "breakpoints", {
    0: {
      slidesPerView: 2.5,
      spaceBetween: 30
    },
    481: {
      slidesPerView: 3.5,
      spaceBetween: 50
    },
    769: {
      slidesPerView: 4.5,
      spaceBetween: 50
    },
    1201: {
      slidesPerView: 5.5,
      spaceBetween: 70
    }
  }), _Swiper)); //    embed slider

  var embedtSlider = new Swiper(".js_four-column-embed-slider", {
    slidesPerView: "auto",
    spaceBetween: 10,
    grabCursor: true,
    updateOnWindowResize: true,
    // centeredSlides: true,
    loop: true,
    threshold: 1,
    navigation: {
      nextEl: ".swiper-button-next-embed-slider",
      prevEl: ".swiper-button-prev-embed-slider "
    }
  });
  var halfcontentSlider = new Swiper(".js_half-content-half-image-slider", {
    slidesPerView: 1,
    resistance: false,
    loop: true,
    spaceBetween: 30,
    // autoplay: {
    //     delay: 10000,
    // },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next-content-slider",
      prevEl: ".swiper-button-prev-content-slider"
    }
  });
  var customProductSlider = new Swiper(".js__product-slider", {
    slidesPerView: "auto",
    spaceBetween: 20,
    grabCursor: false,
    loop: true,
    // loopedSlides: 100,
    updateOnWindowResize: true,
    direction: "horizontal",
    // effect: 'coverflow',
    // freeModeSticky: true,
    freeMode: true,
    freeModeMomentumBounce: false,
    // freeModeMomentumRatio: .1,
    // freeModeMomentumVelocityRatio: .8,
    // freeMode: true,
    // centeredSlides: true,
    threshold: 1,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      481: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      601: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      769: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      981: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20
      },
      1440: {
        slidesPerView: "auto",
        spaceBetween: 20
      }
    },
    navigation: {
      nextEl: ".swiper-button-next-product-slider",
      prevEl: ".swiper-button-prev-product-slider "
    }
  });
  var blogSlider = new Swiper(".js__blog-slider", {
    slidesPerView: "auto",
    spaceBetween: 20,
    threshold: 1,
    loop: true,
    breakpoints: {
      1920: {
        slidesPerView: "auto"
      }
    },
    navigation: {
      nextEl: ".swiper-button-next-blog-slider",
      prevEl: ".swiper-button-prev-blog-slider "
    }
  });
  var productSlider = new Swiper(".js__small-product-slider", {
    slidesPerView: 3,
    spaceBetween: 25,
    loop: true,
    threshold: 1,
    breakpoints: {
      1025: {
        slidesPerView: 3,
        spaceBetween: 25
      },
      981: {
        slidesPerView: 2,
        spaceBetween: 25
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 25
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 25
      }
    },
    navigation: {
      nextEl: ".swiper-button-next-small-product-slider",
      prevEl: ".swiper-button-prev-small-product-slider "
    }
  });
  var swiper = new Swiper(".js__recommendations-product-slider", {
    slidesPerView: 1,
    spaceBetween: 21,
    slidesPerGroup: 1,
    pagination: {
      el: ".swiper-pagination-product",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next-product",
      prevEl: ".swiper-button-prev-product"
    },
    breakpoints: {
      601: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 25
      },
      981: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 25
      },
      1101: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 25
      }
    }
  });
  /* Collection selected*/

  $(document).ready(function ($) {
    $(".js__collections-select").change(function () {
      window.location = $(this).val();
    });
    /*Dropdown selected*/

    $(".js__collection-content li").each(function (index) {
      var value = $(this).attr("data-url").toLowerCase();

      if (window.location.href.toLowerCase().indexOf(value) > -1) {
        $(this).addClass("active");
        $(".js__collections-select").val($(this).attr("data-url"));
      }
    });

    if (!("ontouchstart" in document.documentElement)) {
      document.documentElement.className += " no-touch";
    }
  });

  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch (_unused) {}
  /* PDP
    Tab working */


  $(".tab-link").on("click", function (event) {
    event.preventDefault(); // stop page from jumping

    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    this.className += " active"; // Update dropdown value when tab is clicked

    $(".js__pdp-tab-select").val(dataId);
  });
  $(".js__pdp-tab-select").change(function () {
    $("#tab-link-" + $(this).val()).click();
  });
  $(document).on("click", ".pdp-tab-link", function (e) {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("pdp-tab-content");
    $(this).parent("li").parent("ul").parent(".pdp-tab-small__wrapper__head").parent(".pdp-tab-small__wrapper").children(".pdp-tab-small__wrapper__content").children(".pdp-tab-content").hide();
    $(this).parent("li").parent("ul").parent(".pdp-tab-small__wrapper__head").parent(".pdp-tab-small__wrapper__head-outer").parent(".pdp-tab-small__wrapper").children(".pdp-tab-small__wrapper__content").children(".pdp-tab-content").hide();
    $(this).parent("li").parent("ul").children("li").children(".pdp-tab-link").removeClass("active");
    tablink = document.getElementsByClassName("pdp-tab-link");
    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
    $(this).addClass("active");
    /*PDP select*/

    $(".js__pdp-tab-select").val(dataId);
  });
  /* GLOBAL
    Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  /* accordion working about content in small screen*/

  $(".js__accordian").children("li").children("h2,h4,h5,h3,.feature-header").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  $(document).on("click", ".pid-content-box", function () {
    if ($(this).find(".pid-content-expander").html() != "") {
      if ($(this).parent(".pid-content-flex").children(".pid-content-description").css("display") == "none") {
        $(this).parent(".pid-content-flex").children(".pid-content-description").slideDown();
        $(this).addClass("active");
      } else {
        $(this).parent(".pid-content-flex").children(".pid-content-description").slideUp();
        $(this).removeClass("active");
      }
    }
  });
  /* Accordion working when we have multiple content*/

  $(".js__accordians").children("li").attr("aria-expanded", false);
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("role", "button");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("tabindex", "0");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").click(function (e) {
    var type = $(this).parent("li").attr("data-attr");

    if ($("." + type).css("display") == "none") {
      $(this).attr("aria-expanded", true);
      $(this).parent("li").parent(".js__accordians").children(".content").hide();
      $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
      $("." + type).slideDown();
      $(this).parent("li").addClass("active");
      $(this).addClass("active");
    } else {
      $(this).attr("aria-expanded", false);
      $(this).parent("li").removeClass("active");
      $("." + type).slideUp();
      $(this).removeClass("active");
    }
  });
  $(".js__accordians").children("li").children("h5,h6,h3,h4").keypress(function (e) {
    if (e.which == 13) {
      var type = $(this).parent("li").attr("data-attr");

      if ($("." + type).css("display") == "none") {
        $(this).attr("aria-expanded", true);
        $(this).parent("li").parent(".js__accordians").children(".content").hide();
        $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
        $("." + type).slideDown();
        $(this).parent("li").addClass("active");
        $(this).addClass("active");
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parent("li").removeClass("active");
        $("." + type).slideUp();
        $(this).removeClass("active");
      }
    }
  });
});
/** Dropdown **/

jQuery(function ($) {
  $(".js__cate-accordian .togglebtn h3").on("click", function () {
    if ($(".js__cate-accordian").children(".rem").css("display") == "none") {
      $(".rem").slideDown(300);
      $(this).parent(".togglebtn").toggleClass("active");
    } else {
      $(".rem").slideUp(300);
      $(".togglebtn").removeClass("active");
    }
  });
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }

    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");

      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }

      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
  $(".js__active-class li a").each(function () {
    if (this.href === path) {
      $(".js__active-class li a").removeClass("active");
      $(this).addClass("active");
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */

var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }

    lastScroll = scroll;
  });
});
/** Dropdown **/

jQuery(function ($) {
  /*Blog dropdown*/
  $(".js__blog-select").change(function () {
    window.location = $(this).val();
  });
  /*Dropdown selected*/

  $(".js__blog-select option").each(function (index) {
    var value = $(this).val().toLowerCase();

    if (window.location.href.toLowerCase().indexOf(value) > -1) {
      $(".js__blog-select").val($(this).val());
    }
  });
});
jQuery(function ($) {
  $(".js--open-rates-popup").on("click", function () {
    $(".js__rates-popup").show();
  });
  $(".js__modal-close").on("click", function () {
    $(".modal").hide();
  });
  $(document).keydown(function (event) {
    if (event.keyCode == 27) {
      $(".modal").hide();
    }
  });
});
/*First tab link and first tab content active */

jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".pdp-tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
  $(".pdp-tab-section .tab-content").first().show();
  $(".pdp-tab-small .tab-content").first().show();
  $(".pdp-tab-content").first().show(); // Initialize dropdown to first tab on page load

  var firstTabDataAttr = $(".pdp-tab-section .tab-link").first().attr("data-attr");

  if (firstTabDataAttr) {
    $(".pdp-tab-section .js__pdp-tab-select").val(firstTabDataAttr);
  }

  $(document).on("click", ".js__tab-small", function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".accordion-con").css("display") == "none") {
      // $(".accordion-con").slideUp();
      // $(".accordion-con").removeClass("active");
      // $(".accordion-link").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(".tab-link").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").slideDown();
      $(this).parent(".tab-content").children(".accordion-con").addClass("active"); // $(this).parent(".tab-content").addClass("active");

      $(this).parent(".tab-content").children(".accordion-link").addClass("active");
      var dataId = $(this).parent(".tab-content").attr("data-attr");
      document.getElementById(dataId).className += " active";
      $("html,body").animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      // $(".accordion-con").slideUp();
      // $(".accordion-con").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-link").removeClass("active"); // $(this).parent(".tab-content").removeClass("active");

      $(this).parent(".tab-content").children(".accordion-con").removeClass("active");
    }
  });
  $(document).on("click", ".js___accordion", function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".accordion-con").css("display") == "none") {
      $(".accordion-con").slideUp();
      $(".accordion-con").removeClass("active");
      $(".accordion-link").removeClass("active"); // $(".tab-content").removeClass("active");

      $(".tab-link").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").slideDown();
      $(this).parent(".tab-content").children(".accordion-con").addClass("active"); // $(this).parent(".tab-content").addClass("active");

      $(this).parent(".tab-content").children(".accordion-link").addClass("active");
      var dataId = $(this).parent(".tab-content").attr("data-attr");
      document.getElementById(dataId).className += " active";
      $("html,body").animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      $(".accordion-con").slideUp();
      $(".accordion-con").removeClass("active"); // $(".tab-content").removeClass("active");

      $(this).parent(".tab-content").children(".accordion-link").removeClass("active"); // $(this).parent(".tab-content").removeClass("active");

      $(this).parent(".tab-content").children(".accordion-con").removeClass("active");
    }
  });
});
/*Select Dropdown change wit Tab */

jQuery(function () {
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    var dropdown = $(".dropdown-select").val();
    $(".js__faq-search-section").addClass("hide");
    $(".js__faq-tab").removeClass("hide");
    $("#txt-faq-search").val("");
    $(".js__no-data-found").addClass("hide"); //first hide all tabs again when a new option is selected

    $(".tab-content").hide(); //then show the tab content of whatever option value was selected

    $("#" + "tab-" + dropdown).show();

    if (dropdown == "all") {
      $(".js__tab-content").each(function () {
        if ($(this).find(".js__accordian").html().trim() == "<li>Sorry Data Is Not Added Yet</li>") {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    }
  });
  $(".js__tab-content").each(function () {
    if ($(this).find(".js__accordian").html().trim() == "") {
      $(this).find(".js__accordian").html("<li>Sorry Data Is Not Added Yet</li>");
    }
  });
});
/*Blog content checking if p tag has image then adding class*/

jQuery(function ($) {
  $(".article-content p").each(function () {
    var $p = $(this); // Check if paragraph has img or iframe

    if ($p.find("img, iframe").length) {
      $p.addClass("full-width"); // Wrap text nodes

      $p.contents().each(function () {
        if (this.nodeType === 3 && this.nodeValue.trim().length > 0) {
          $(this).replaceWith('<span class="text-content">' + this.nodeValue + "</span>");
        }
      });
    } else {
      // Wrap text-only paragraphs
      if (!$p.find("span.text-content").length) {
        $p.contents().filter(function () {
          return this.nodeType === 3 && this.nodeValue.trim().length > 0;
        }).wrap('<span class="text-content"></span>');
      }
    } // 👇 check for video after everything


    if ($p.find(".video-wrapper").length) {
      $p.addClass("has-video");
    }
  });
}); // jQuery(document).ready(function ($) {
//     // Get the element
//     for (var i = 0; i < 250; i++) {
//       var marqueeFooter = document.querySelector('.js__marquee-right .repeat');
//       // Create a copy of it
//       var cloneFooter = marqueeFooter.cloneNode(true);
//       // Inject it into the DOM
//       marqueeFooter.before(cloneFooter);
//     }
//   });

/* quick view modal pop up */

/*Quantity Plus Minus*/

$(document).on("click", ".js__popup-quantity .js-plus-minus-qty", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var type = $(this).attr("data-type");
  var $quantityInput = $(this).parent(".js__popup-quantity").find(".qty-val");
  var productQuantity = parseInt($quantityInput.val()) || 1;

  if (type == "minus") {
    if (productQuantity > 1) {
      productQuantity--;
    }
  } else {
    productQuantity++;
  }

  $quantityInput.val(productQuantity);
});
/* Product card click - open quick view pop up */

/*$(document).on("click", ".js__quick-view-click", function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var id = $(this).attr("data-id");
  //Executed after SWYM has loaded all necessary resources.

  var productTItle = $(this).attr("title");
  $(".js__popup-product-name-" + id).html(productTItle);

  $(".js__popup-variant-select-" + id + " li:first-child").click();
  // show modal pop up
  $("#modal-" + id).show();
});*/

/* Quick View - Variant Radio Button Clicks */

$(document).on("click", ".js__popup-variant-select li", function (e) {
  $(this).parent("ul").children("li").removeClass("active");
  var option = $(this).attr("data-value");
  var optionDisplayText = $(this).text() || $(this).html(); // Get the displayed text as well

  var optionPosition = parseInt($(this).attr("data-option")) || 1; // Get which option position (1, 2, or 3)

  $(this).addClass("active");
  var pID = $(this).attr("data-id"); // Validate required attributes

  if (!pID) {
    return;
  }

  var $productSelect = $("#product-select-" + pID);

  if ($productSelect.length === 0) {
    return;
  } // Normalize the option value for comparison - handles quotes, whitespace, and HTML entities


  var normalizeString = function normalizeString(str) {
    if (!str) return "";
    var text = str.toString(); // Decode HTML entities

    var tempDiv = $("<div>").html(text);
    text = tempDiv.text() || text; // Normalize all types of quotes to a single quote character

    text = text.replace(/[""''`]/g, '"'); // Normalize whitespace

    text = text.replace(/\s+/g, " ");
    return text.trim();
  }; // Check if data-value seems incomplete (shorter than displayed text by significant amount)
  // This handles cases where data-value is malformed due to unescaped quotes in HTML


  var normalizedDisplayText = normalizeString(optionDisplayText);
  var normalizedOption = option ? normalizeString(option) : ""; // If data-value is missing or significantly shorter than displayed text, prioritize displayed text
  // Also check if they're very different (data-value might be truncated due to quote issues)

  var useDisplayText = false;

  if (!normalizedOption || normalizedDisplayText.length > normalizedOption.length * 1.5) {
    useDisplayText = true;
  } // Build array of options to try - prioritize displayed text if data-value seems broken


  var optionsToTry = [];

  if (useDisplayText && normalizedDisplayText) {
    optionsToTry.push(normalizedDisplayText);
  }

  if (normalizedOption && normalizedOption !== normalizedDisplayText) {
    optionsToTry.push(normalizedOption);
  }

  if (!useDisplayText && normalizedDisplayText) {
    optionsToTry.push(normalizedDisplayText);
  }

  var matchFound = false;
  $productSelect.find("option").each(function (index) {
    if (matchFound) {
      return false; // Break loop
    } // Use text() instead of html() to get plain text content without HTML encoding issues


    var optionName = $(this).text() || $(this).html();
    var vID = $(this).attr("value");
    var variantSoldout = $(this).attr("data-soldout");
    var price = $(this).attr("data-price"); // Validate optionName before processing

    if (!optionName || !vID) {
      return true; // Continue to next iteration
    } // Normalize the option name for comparison


    var normalizedOptionName = normalizeString(optionName); // Try multiple matching strategies:

    var isMatch = false; // 1. Exact match (for single option products)

    for (var optIdx = 0; optIdx < optionsToTry.length && !isMatch; optIdx++) {
      var currentOption = optionsToTry[optIdx];

      if (normalizedOptionName === currentOption) {
        isMatch = true;
        break;
      }
    } // 2. If not exact match, try splitting by common separators (/, -, |)
    // This handles multi-option products where variant.title = "Option1 / Option2 / Option3"


    if (!isMatch) {
      var separators = [" / ", " - ", " | ", " /", "/ ", " -", "- ", " |", "| ", "/", "-", "|"];
      var variantParts = [normalizedOptionName]; // Split by separators

      for (var i = 0; i < separators.length; i++) {
        if (normalizedOptionName.indexOf(separators[i]) !== -1) {
          variantParts = normalizedOptionName.split(separators[i]).map(function (part) {
            return normalizeString(part);
          });
          break;
        }
      } // Check all parts of the variant title for a match with any of our option values


      for (var optIdx = 0; optIdx < optionsToTry.length && !isMatch; optIdx++) {
        var currentOption = optionsToTry[optIdx];

        for (var j = 0; j < variantParts.length; j++) {
          if (variantParts[j] === currentOption) {
            isMatch = true;
            break;
          }
        }

        if (isMatch) break;
      }
    } // 3. Check if variant title starts with any of our option values (for when it's the first option)


    if (!isMatch) {
      for (var optIdx = 0; optIdx < optionsToTry.length && !isMatch; optIdx++) {
        var currentOption = optionsToTry[optIdx];

        if (normalizedOptionName.indexOf(currentOption) === 0) {
          isMatch = true;
          break;
        }
      }
    } // 4. Fallback: Check if option value is contained anywhere in variant title
    // This handles edge cases where format might be different or has extra characters


    if (!isMatch) {
      for (var optIdx = 0; optIdx < optionsToTry.length && !isMatch; optIdx++) {
        var currentOption = optionsToTry[optIdx];

        if (currentOption.length >= 3 && normalizedOptionName.indexOf(currentOption) !== -1) {
          isMatch = true;
          break;
        }
      }
    } // 5. Final fallback: Compare normalized versions removing all special characters except alphanumeric and spaces
    // This is the most lenient check for edge cases with special formatting


    if (!isMatch) {
      var cleanOptionName = normalizedOptionName.replace(/[^a-zA-Z0-9\s]/g, "").toLowerCase().trim();

      for (var optIdx = 0; optIdx < optionsToTry.length && !isMatch; optIdx++) {
        var currentOption = optionsToTry[optIdx];

        if (currentOption.length >= 3) {
          var cleanOption = currentOption.replace(/[^a-zA-Z0-9\s]/g, "").toLowerCase().trim();

          if (cleanOption && cleanOptionName.indexOf(cleanOption) !== -1) {
            isMatch = true;
            break;
          }
        }
      }
    }

    if (isMatch) {
      matchFound = true;
      var $priceContainer = $(".js__price-popup-price-" + pID);

      if ($priceContainer.length) {
        var displayPrice = price || optionName;

        if (displayPrice) {
          var decodedPrice = $("<div>").html(displayPrice).text();
          var $priceTextEl = $priceContainer.find(".js__price-popup-price-text");

          if (!$priceTextEl.length) {
            $priceTextEl = $priceContainer.find("span").first();
          }

          if ($priceTextEl.length) {
            $priceTextEl.text(decodedPrice);
          } else {
            $priceContainer.text(decodedPrice);
          }

          var numericPrice = decodedPrice.replace(/[^0-9.,]/g, "").replace(/,/g, "");
          var numericPriceValue = parseFloat(numericPrice);

          if (!isNaN(numericPriceValue)) {
            $priceContainer.attr("content", numericPriceValue.toFixed(2));
          }
        }

        $priceContainer.css("display", "").show();
      }

      $productSelect.val(vID);

      if (variantSoldout == "true") {
        $(".js__modal-popup-qty-" + pID).hide();
        $(".js__modal-popup-addtocart-" + pID).attr("disabled", "disabled"); //update the text for the add to cart button to sold out

        $(".js__modal-popup-addtocart-" + pID).html("Soldout");
      } else {
        $(".js__modal-popup-qty-" + pID).show(); //update the text for the button to add to cart, if not sold out

        $(".js__modal-popup-addtocart-" + pID).html("Add to Cart"); // if not sold out, then remove the attr disabled

        $(".js__modal-popup-addtocart-" + pID).removeAttr("disabled");
      } // update the variant ID for the data-variant-id


      $(".js__modal-popup-addtocart-" + pID).attr("data-variant-id", vID);
      /* Not sure what are they being used for */
      // $(".discount_variant-" + pID + " span").hide();
      //$(".js__popup-variant-price-" + vID).show();
      //$(".js__rc_block__type__onetime-" + pID).find(".rc_price__onetime").html(price);
      //$(".modal-popup-price-subcription-" + pID).html($(".js__popup-variant-price-" + vID).html());

      return false; // Break loop
    }
  });
  /* Not being used any more */
  //$(".js__rc_radio_options-" + pID + " .rc_block__type-modal-popup.rc_block__type--active").click();
}); // Prevent all mouse events from propagating to avoid triggering cart close

$(document).on("mousedown", ".js__modal-popup-addtocart", function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation(); // Set flag immediately on mousedown

  window.cartJustOpened = true;
  window.cartOpenTime = Date.now();
  window.addingFromModal = true;
});
$(document).on("mouseup", ".js__modal-popup-addtocart", function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation(); // Keep flag set on mouseup too

  window.cartJustOpened = true;
  window.cartOpenTime = Date.now();
  window.addingFromModal = true;
});
$(document).on("click", ".js__modal-popup-addtocart", function (e) {
  // Prevent event propagation to avoid triggering cart close
  e.stopPropagation();
  e.stopImmediatePropagation();
  e.preventDefault(); // Set flag immediately to prevent cart from closing when it opens

  window.cartJustOpened = true;
  window.cartOpenTime = Date.now();
  window.addingFromModal = true;
  console.log("click");
  var pID = $(this).attr("data-id");
  console.log("pID" + pID);
  var selectedVariantID = $(this).attr("data-variant-id");
  console.log("pID" + selectedVariantID);
  var quantity = parseInt($(".js-quantity-selector-" + pID).val());
  var recharge = $(".js__rc_radio_options-" + pID).html();
  var items = []; // If this modal's product has a complementary (add-on) product, we may need
  // to flag the main line item with an Add-on property and optionally add the
  // complimentary variant itself.

  var $modal = $("#modal-" + pID);
  var $complementaryBlock = $modal.find(".product__complementary-option");
  var $discountedDishData = $modal.find(".product__discounted-dish-data");
  var discountedDishVariantId = $discountedDishData.length ? $discountedDishData.attr("data-discounted-dish-variant-id") : null;
  var choice = "with";
  var addonVariantId = null;
  var addonTitle = null;
  var withLabel = null;
  var withoutLabel = null;

  if ($complementaryBlock.length) {
    var choiceSelect = $modal.find("#modal-complementary-choice-" + pID);
    choice = choiceSelect.length ? choiceSelect.val() : "with";
    addonVariantId = $complementaryBlock.attr("data-complementary-variant-id");
    addonTitle = $complementaryBlock.attr("data-addon-title") || "Add-on";
    withLabel = "With " + addonTitle;
    withoutLabel = "Without " + addonTitle;
  }

  if (recharge == undefined) {
    // Main item (one-time purchase)
    var mainItem = {
      id: selectedVariantID,
      quantity: quantity
    };

    if ($complementaryBlock.length) {
      mainItem.properties = mainItem.properties || {};
      mainItem.properties["Add-on"] = choice === "without" ? withoutLabel : withLabel;

      if (choice !== "without" && addonVariantId) {
        mainItem.properties["_complementary_variant_id"] = String(addonVariantId);
      }
    }

    if (discountedDishVariantId) {
      mainItem.properties = mainItem.properties || {};
      mainItem.properties["_discounted_dish_variant_id"] = String(discountedDishVariantId);
    }

    items.push(mainItem);
  } else {
    // Main item (subscription logic preserved)
    if ($(".js__rc_radio_options-" + pID + " .rc_block__type-modal-popup.rc_block__type--active").hasClass("rc_block__type__onetime")) {
      var mainItemOneTime = {
        id: selectedVariantID,
        quantity: quantity
      };

      if ($complementaryBlock.length) {
        mainItemOneTime.properties = mainItemOneTime.properties || {};
        mainItemOneTime.properties["Add-on"] = choice === "without" ? withoutLabel : withLabel;

        if (choice !== "without" && addonVariantId) {
          mainItemOneTime.properties["_complementary_variant_id"] = String(addonVariantId);
        }
      }

      if (discountedDishVariantId) {
        mainItemOneTime.properties = mainItemOneTime.properties || {};
        mainItemOneTime.properties["_discounted_dish_variant_id"] = String(discountedDishVariantId);
      }

      items.push(mainItemOneTime);
    } else {
      var shippingIntervalFrequency = $(".js__shipping_interval_frequency-" + pID).val();
      var shippingIntervalUnitType = $(".js__shipping_interval_unit_type-" + pID).html();
      var mainItemSub = {
        id: selectedVariantID,
        quantity: quantity,
        "properties[shipping_interval_frequency]": shippingIntervalFrequency,
        "properties[shipping_interval_unit_type]": shippingIntervalUnitType
      };

      if ($complementaryBlock.length) {
        mainItemSub.properties = mainItemSub.properties || {};
        mainItemSub.properties["Add-on"] = choice === "without" ? withoutLabel : withLabel;

        if (choice !== "without" && addonVariantId) {
          mainItemSub.properties["_complementary_variant_id"] = String(addonVariantId);
        }
      }

      if (discountedDishVariantId) {
        mainItemSub.properties = mainItemSub.properties || {};
        mainItemSub.properties["_discounted_dish_variant_id"] = String(discountedDishVariantId);
      }

      items.push(mainItemSub);
    }
  } // If this modal's product has a complementary (add-on) product and the
  // customer chose "Yes", push the add-on variant into the same CartJS call.


  if ($complementaryBlock.length && addonVariantId) {
    if (choice !== "without") {
      // Only _complementary_addon on the complimentary line item.
      // No _parent_url — it differs per parent and prevents clubbing.
      items.push({
        id: addonVariantId,
        quantity: quantity,
        properties: {
          _complementary_addon: "1"
        }
      });
    }
  } // Auto-add discounted dish if this product has one


  if (discountedDishVariantId) {
    items.push({
      id: discountedDishVariantId,
      quantity: quantity,
      properties: {
        _discounted_dish_addon: "1"
      }
    });
  }

  CartJS.addItems(items, {
    success: function success(response, textStatus, jqXHR) {
      console.log("success"); // Hide modal after a small delay to ensure click events are processed

      setTimeout(function () {
        $(".modal-quick-view").hide();
      }, 100);

      if (getglobalLib("Mini_Cart") == "yes") {
        /* Show message */
        // Open cart after modal is hidden
        setTimeout(function () {
          openMiniCart(); // Clear the modal flag after cart is fully opened

          setTimeout(function () {
            window.addingFromModal = false;
          }, 500);
        }, 600);
      } else {
        window.location = "/cart";
      }
    },
    // Define an error callback to display an error message.
    error: function error(jqXHR, textStatus, errorThrown) {
      showCartErrorMessage();
      console.log("error");
    }
  });
});
$(document).on("click", ".js__quick-view-popup-close", function (e) {
  e.preventDefault();
  e.stopPropagation();
  $(".modal-quick-view").hide();
});
jQuery(document).ready(function ($) {
  $(".hero-banner-slider .content").addClass("animate");
});
$(document).ready(function ($) {
  $(".js__btn-faq-search").on("click", function () {
    var search = $("#txt-faq-search").val().toLowerCase();

    if (search != "") {
      $(".js__no-data-found").removeClass("hide");
      $(".tab-link").removeClass("active");
      $(".dropdown-select").val("all"); //Go through each list item and hide if not match search

      $(".js__faq-search-section").removeClass("hide");
      $(".js__faq-search-section").find(".tab-content").show();
      $(".js__faq-tab").addClass("hide");
      $(".js__faq-search li").each(function () {
        if ($(this).children("h3").html().toLowerCase().indexOf(search) != -1) {
          $(this).show();
          $(".js__no-data-found").addClass("hide");
        } else {
          $(this).hide();
        }
      });
    }
  });
});
jQuery(document).ready(function ($) {
  $(document).on("click", ".js__card-add-to-cart", function (e) {
    console.log("add to cart clicked");
    var selectedVariantID = $(this).attr("data-variant-id");
    var quantity = 1;
    var items = [];
    /* For the main item */

    items.push({
      id: selectedVariantID,
      quantity: quantity
    });
    CartJS.addItems(items, {
      success: function success(response, textStatus, jqXHR) {
        console.log("success adding to cart");
        $(".modal-quick-view").hide();
        $(".js__card-add-to-cart-" + selectedVariantID).addClass("added");
        $(".js__card-add-to-cart-" + selectedVariantID).html("Added");

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      // Define an error callback to display an error message.
      error: function error(jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
        console.log("error adding to cart");
      }
    });
  });
});
jQuery(document).ready(function ($) {
  $(".js__read-mode-toggle").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).parent(".mobile-block").parent(".js__description-outer").find(".desktopdescription").removeClass("active");
      $(this).removeClass("active");
      $(this).html("Read More");
    } else {
      $(this).parent(".mobile-block").parent(".js__description-outer").find(".desktopdescription").addClass("active");
      $(this).addClass("active");
      $(this).html("Read Less");
    }
  });
});
$(document).ready(function () {
  function hideBlogExtraSections() {
    // Run only on blog pages
    if (window.location.pathname.includes("/blogs/")) {
      var params = new URLSearchParams(window.location.search);
      var currentPage = params.get("page"); // Hide featured and popular sections if not first page

      if (currentPage && currentPage !== "1") {
        $(".featured-blog-section, .three-column-blog-slider").hide();
      }
    }
  } // Wait until those sections actually load (important for JSON templates)


  var checkSections = setInterval(function () {
    if ($(".featured-blog-section").length || $(".three-column-blog-slider").length) {
      hideBlogExtraSections();
      clearInterval(checkSections);
    }
  }, 300); // Also run immediately in case they’re already present

  hideBlogExtraSections();
});
jQuery(document).ready(function ($) {
  var $popup = $(".article-video-popup"); // 🔹 Open popup

  $(".video-wrapper").on("click", function () {
    var id = $(this).attr("data-id");
    $("#modal-video-popup-" + id).fadeIn(200).css("display", "flex");
  }); // 🔹 Close popup on close button OR clicking outside

  /* $(".close-popup, .article-video-popup").on("click", function (e) {
    if ($(e.target).is(".article-video-popup, .close-popup")) {
      $popup.fadeOut(200);
    }
  });*/

  $(document).on("click", ".article-video-popup", function (e) {
    if (!($(e.target).closest(".video-popup-inner").length > 0 || $(e.target).closest(".close-popup").length > 0)) {
      $(this).hide();
    }
  });
  $(".close-popup").on("click", function () {
    $(".article-video-popup").hide();
  });
  $(document).keydown(function (event) {
    if (event.keyCode == 27) {
      $(".article-video-popup").hide();
    }
  });
});
/* quick view modal pop up */

var popupCollectionSlider;
var popupCollectionSliderThumbnail;
jQuery(function () {
  $(document).on("click", ".modal", function (e) {
    if (!($(e.target).closest(".modal-content").length > 0 || $(e.target).closest(".close").length > 0)) {
      $(this).hide();
    }
  });
  /* Quick View - Variant Radio Button Clicks */

  $(document).on("click", ".js__popup-variant-select li", function (e) {
    $(this).parent("ul").children("li").removeClass("active");
    var option = $(this).attr("data-value");
    $(this).addClass("active");
    var pID = $(this).attr("data-id");
    console.log("pID" + pID);
    $("#product-select-" + pID + " option").each(function (index) {
      var optionName = $(this).html();
      var vID = $(this).attr("value");
      var variantSoldout = $(this).attr("data-soldout");
      var price = $(this).attr("data-price");

      if (optionName.trim() == option.trim()) {
        $(".js__price-popup-price-" + pID).hide();
        $(".js__price-popup-" + vID).show();

        if (variantSoldout == "true") {
          $(".js__modal-popup-addtocart-" + pID).attr("disabled", "disabled"); //update the text for the add to cart button to sold out

          $(".js__modal-popup-addtocart-text-" + pID).html("Soldout"); //hide the price if it's sold out
        } else {
          //update the text for the button to add to cart, if not sold out
          $(".js__modal-popup-addtocart-text-" + pID).html("Add to Cart"); // if not sold out, then remove the attr disabled

          $(".js__modal-popup-addtocart-" + pID).removeAttr("disabled");
        } // update the variant ID for the data-variant-id


        $(".js__modal-popup-addtocart-" + pID).attr("data-variant-id", vID);
        /* Not sure what are they being used for */
        // $(".discount_variant-" + pID + " span").hide();
        //$(".js__popup-variant-price-" + vID).show();
        //$(".js__rc_block__type__onetime-" + pID).find(".rc_price__onetime").html(price);
        //$(".modal-popup-price-subcription-" + pID).html($(".js__popup-variant-price-" + vID).html());
      }
    });
    /* Not being used any more */
    //$(".js__rc_radio_options-" + pID + " .rc_block__type-modal-popup.rc_block__type--active").click();
  }); // $(document).on("change", ".js__shipping_interval_frequency", function (e) {
  //     var id = $(this).attr("data-id");
  //     if ($(this).val() != "") {
  //         $(".js__modal-popup-addtocart-" + id).addClass("hide");
  //         $(".js__modal-popup-addtocart-subcription-" + id).removeClass("hide");
  //         $(".js__modal-popup-addtocart-" + id).removeAttr("disabled");
  //         $(".js__modal-popup-addtocart-text-" + id).html("Add to Cart - ");
  //         $(".modal-popup-price-" + id).css("display", "inline-block")
  //     } else {
  //         $(".js__modal-popup-addtocart-" + id).removeClass("hide");
  //         $(".js__modal-popup-addtocart-subcription-" + id).addClass("hide");
  //         $(".js__modal-popup-addtocart-" + id).attr("disabled", "disabled");
  //         $(".js__modal-popup-addtocart-text-" + id).html("Select Frequency");
  //         $(".modal-popup-price-" + id).css("display", "none")
  //     }
  // })
  // $(document).on("click", ".js__rc_block__type__onetime-modal-popup", function (e) {
  //     var id = $(this).attr("data-id");
  //     $(".js__modal-popup-addtocart-" + id).removeClass("hide");
  //     $(".js__modal-popup-addtocart-subcription-" + id).addClass("hide");
  //     $(".js__modal-popup-addtocart-" + id).removeAttr("disabled");
  //     $(".js__modal-popup-addtocart-text-" + id).html("Add to Cart - ");
  //     $(".modal-popup-price-" + id).css("display", "inline-block")
  // })
  // $(document).on("click", ".js__rc_block__type__autodeliver-modal-popup", function (e) {
  //     var id = $(this).attr("data-id");
  //     $(".js__modal-popup-addtocart-" + id).attr("disabled", "disabled");
  //     $(".js__shipping_interval_frequency-" + id).change();
  // })

  $(document).on("click", ".js__modal-popup-addtocart", function (e) {
    var pID = $(this).attr("data-id");
    var selectedVariantID = $(this).attr("data-variant-id");
    var quantity = parseInt($(".js-quantity-selector-" + pID).val());
    var recharge = $(".js__rc_radio_options-" + pID).html();
    var items = [];

    if (recharge == undefined) {
      /* For the main item */
      items.push({
        id: selectedVariantID,
        quantity: quantity
      });
    } else {
      if ($(".js__rc_radio_options-" + pID + " .rc_block__type-modal-popup.rc_block__type--active").hasClass("rc_block__type__onetime")) {
        items.push({
          id: selectedVariantID,
          quantity: quantity
        });
      } else {
        var shippingIntervalFrequency = $(".js__shipping_interval_frequency-" + pID).val();
        var shippingIntervalUnitType = $(".js__shipping_interval_unit_type-" + pID).html();
        items.push({
          id: selectedVariantID,
          quantity: quantity,
          "properties[shipping_interval_frequency]": shippingIntervalFrequency,
          "properties[shipping_interval_unit_type]": shippingIntervalUnitType
        });
      }
    }

    CartJS.addItems(items, {
      success: function success(response, textStatus, jqXHR) {
        $(".modal-quick-view").hide();

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      // Define an error callback to display an error message.
      error: function error(jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
      }
    });
  });
  $(document).on("click", ".js__card-add-to-cart", function (e) {
    var selectedVariantID = $(this).attr("data-variant-id");
    var quantity = 1;
    var items = [];
    /* For the main item */

    items.push({
      id: selectedVariantID,
      quantity: quantity
    });
    CartJS.addItems(items, {
      success: function success(response, textStatus, jqXHR) {
        $(".modal-quick-view").hide();

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      // Define an error callback to display an error message.
      error: function error(jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
      }
    });
  });
  $(document).on("click", ".js__popup-collection-slider-thumbnail .slide", function (e) {
    var slideno = parseInt($(this).index());
    e.preventDefault();
    e.stopPropagation();
    popupCollectionSlider.slideTo(slideno, 1000, false);
  });
  $(document).on("click", ".js__quick-view-popup-close", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".modal-quick-view").hide();
  });
  var modal = document.getElementById("js__ingredients-popup"); // When the user clicks anywhere outside of the modal, close it

  window.onclick = function (event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
}); // Article Content Modal Popup

jQuery(document).ready(function ($) {
  var $articlePopup = $(".article-content-popup"); // Open article modal on Read More click

  $(document).on("click", ".js-open-article-modal", function (e) {
    e.preventDefault();
    var articleId = $(this).attr("data-article-id"); // Modal ID is already sanitized in Liquid template

    var modalId = "modal-article-" + articleId;
    $("#" + modalId).fadeIn(200).css("display", "flex"); // Prevent body scroll when modal is open

    $("body").css("overflow", "hidden");
  }); // Close popup on close button click

  $(document).on("click", "[data-close-article-popup]", function () {
    $(".article-content-popup").hide();
    $("body").css("overflow", "");
  }); // Close popup when clicking outside the content

  $(document).on("click", ".article-content-popup", function (e) {
    if (!($(e.target).closest(".article-popup-inner").length > 0 || $(e.target).closest("[data-close-article-popup]").length > 0)) {
      $(this).hide();
      $("body").css("overflow", "");
    }
  }); // Close popup on ESC key

  $(document).keydown(function (event) {
    if (event.keyCode == 27) {
      $(".article-content-popup").hide();
      $("body").css("overflow", "");
    }
  });
}); // ------------------------------------------------------------
// Quiz recommendations page – open mini cart when cart count grows
// ------------------------------------------------------------
// On the quiz recommendation page, the Tangent Quiz app adds items
// to the Shopify cart but does not use the theme's own add-to-cart
// handlers. Here we watch the cart item count; whenever it increases
// (meaning something was just added), we open the mini cart so the
// user gets the same feedback as elsewhere in the theme.

(function () {
  // Only run on quiz recommendations pages.
  // Tangent Quiz can create URLs like:
  //   /pages/quiz-recommendations
  //   /pages/quiz-recommendations-2-0
  //   /pages/quiz-recommendations-3?resp_id=...
  // so we just check that the path includes "quiz-recommendations".
  if (!window.location.pathname || window.location.pathname.indexOf("quiz-recommendations") === -1) {
    return;
  } // Helper: get current cart item count via CartJS if available,
  // otherwise via /cart.js.


  function getCartItemCount(callback) {
    try {
      if (typeof CartJS !== "undefined" && CartJS.cart) {
        callback(parseInt(CartJS.cart.item_count || 0, 10));
        return;
      }
    } catch (e) {}

    try {
      fetch("/cart.js", {
        credentials: "same-origin"
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        callback(parseInt(cart && cart.item_count || 0, 10));
      })["catch"](function () {// Ignore errors; we simply won't open mini cart in this tick.
      });
    } catch (e) {// Network not available; ignore.
    }
  }

  var lastItemCount = null; // Initialize lastItemCount

  getCartItemCount(function (count) {
    if (!isNaN(count)) {
      lastItemCount = count;
    }
  }); // Poll for changes every ~1.2s

  var pollInterval = setInterval(function () {
    // If mini cart or openMiniCart is not present any more, stop.
    if (typeof openMiniCart === "undefined") {
      return;
    }

    getCartItemCount(function (count) {
      if (isNaN(count)) return;

      if (lastItemCount !== null && count > lastItemCount) {
        // Respect global mini cart setting if available
        if (typeof getglobalLib === "function") {
          try {
            if (getglobalLib("Mini_Cart") !== "yes") {
              lastItemCount = count;
              return;
            }
          } catch (e) {// If the helper throws, fall back to opening cart anyway.
          }
        } // Delay slightly so cart UI has time to update


        setTimeout(function () {
          try {
            openMiniCart();
          } catch (e) {}
        }, 300);
      }

      lastItemCount = count;
    });
  }, 1200);
})(); // ------------------------------------------------------------
// Quiz recommendations page – fallback: open mini cart on button click
// ------------------------------------------------------------
// Some quiz add-to-cart flows may not update CartJS in a way that our
// polling logic can detect reliably. As a safety net, we also listen
// for clicks on "Add to cart" buttons on quiz recommendation pages
// and force-open the mini cart shortly after.


(function () {
  if (!window.location.pathname || window.location.pathname.indexOf("quiz-recommendations") === -1) {
    return;
  }

  jQuery(function ($) {
    // Generic text-based matcher (buttons/links)
    $(document).on("click", "button, a", function () {
      try {
        var label = ($(this).text() || "").trim().toLowerCase();
        if (!label) return;

        if (label === "add to cart" || label === "added to cart" || label.indexOf("add to cart") !== -1) {
          // Give the app time to finish the add-to-cart request
          setTimeout(function () {
            if (typeof openMiniCart === "function") {
              try {
                jQuery.getJSON("/cart.js", function (cart) {
                  // show message
                  showCartSuccessMessage(); // now have access to Shopify cart object

                  reloadAjaxCartItemUsingCartAjaxObject(cart); //Show and hide empty cart depending upon the cart items
                });
              } catch (e) {}
            }
          }, 800);
        }
      } catch (e) {// Fail silently
      }
    }); // Explicitly handle Tangent Quiz add buttons, which wrap the text
    // inside a <p> with classes like `.tangent_add_to_cart_button` and
    // the clickable area is the surrounding <a.tangent-product-add-btn-wrapper>

    $(document).on("click", ".tangent-product-add-btn-wrapper, .tangent_add_to_cart_button, .tangent-btn-add", function () {
      setTimeout(function () {
        if (typeof openMiniCart === "function") {
          try {
            jQuery.getJSON("/cart.js", function (cart) {
              // show message
              showCartSuccessMessage(); // now have access to Shopify cart object

              reloadAjaxCartItemUsingCartAjaxObject(cart); //Show and hide empty cart depending upon the cart items
            });
          } catch (e) {}
        }
      }, 800);
    });
  });
})(); // jQuery(function ($) {
//   let checkHulk = setInterval(function () {
//     const xProduct = document.querySelector(
//       ".hulkapps-volumes .x_offer_layout",
//     );
//     if (xProduct) {
//       xProduct.remove();
//       // also remove the + icon between X and Y
//       const plusIcon = document.querySelector(".hulkapps-volumes .text-center");
//       if (plusIcon) plusIcon.remove();
//       clearInterval(checkHulk); // stop checking once removed
//     }
//   }, 500); // checks every 500ms
// });
"use strict";

var showCartMessage = true;
jQuery(function () {
  //Nav - Open and Close Mini cart
  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active");
      $(this).addClass("active");
    });
    $("#js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js__cart-expand").removeClass("active");
    }); // Close cart on ESC key press

    $(document).on("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        $("#CartSidebar").removeClass("active");
        $("#cart_overlay").removeClass("active");
        $(".js__cart-expand").removeClass("active");
      }
    });
    $(".js__cart-expand").attr("href", "javascript:void(0)");
  }
  /* Cart - Free Shipping Progress bar Visiblity */


  try {
    if (getglobalLib("Free_Shipping_progressbar") == "yes" && $(".js__free-shipping-limit").html().trim() != "" && showProgressBar == true) {
      $(".js__progressbar_visiblity").removeClass("hide");
    }
  } catch (_unused) {}
  /* Remove mini cart from the cart page */


  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });

  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/

function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);

  if (showCartMessage == true) {
    $("#cart-message").addClass("message-success");
    $("#cart-message").removeClass("message-error");
    $("#cart-message").html("Successfully added to cart!");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}

function showCartErrorMessage() {
  if (showCartMessage == true) {
    $("#cart-message").removeClass("message-success");
    $("#cart-message").addClass("message-error");
    $("#cart-message").html("Sorry! Seems like the product is out of stock");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}

function openMiniCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    window.cartJustOpened = true;
    window.cartOpenTime = Date.now();
    $("#CartSidebar").toggleClass("active");
    $("#cart_overlay").toggleClass("active"); // Clear the flags after 3 seconds (longer for modal adds)

    setTimeout(function () {
      window.cartJustOpened = false; // Only clear addingFromModal if it was set (don't interfere with other flows)

      if (window.addingFromModal) {
        setTimeout(function () {
          window.addingFromModal = false;
        }, 1000);
      }
    }, 3000);
  });
}
/* EVENT: When the cart request is completed everytime the below function is run */


$(document).on("cart.requestComplete", function (event, cart) {
  reloadAjaxCartItemUsingCartAjaxObject(cart);
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */


  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }

  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    $("#js__pdp-recommendation-slider").not(".slick-initialized").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      variableWidth: true,
      draggable: true
    });
  }
});
"use strict";

document.addEventListener("DOMContentLoaded", function () {
  if (window.Swiper) {
    new Swiper(".js__announcement-slider", {
      slidesPerView: 1,
      resistance: false,
      shortSwipes: true,
      loop: false,
      // autoHeight: true,
      autoplay: {
        delay: 10000
      }
    });
  } else {
    console.warn("Swiper is not loaded!");
  } //Close Announcement Bar on Click

  /* document
    .getElementById("announcement-close")
    .addEventListener("click", function () {
      document.querySelector(".announcement-bar").style.display = "none";
      document.body.classList.remove("announcement-visible");
    });*/

}); // SUB MENU And BIG NAV

document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("mainHeader");
  var body = document.body;

  var pageHasHero = function pageHasHero() {
    return !!document.querySelector(".hero-banner, .inner-hero-section, .collection-hero-section");
  };

  var subItems = document.querySelectorAll(".has-sub-nav");
  var bigItems = document.querySelectorAll(".has-big-nav");
  /** Updated on pointer move; used so scroll only closes mega when cursor is not over the menu. */

  var lastPointerClientX = 0;
  var lastPointerClientY = 0;
  var hasPointerPosition = false;
  var searchBtn = document.getElementById("js__header-search-btn");
  var searchSection = document.getElementById("js-header-search-section");

  var isSearchOpen = function isSearchOpen() {
    return searchBtn && searchBtn.dataset.open === "true" || searchSection && searchSection.classList.contains("visible");
  };

  var forceCloseSearch = function forceCloseSearch() {
    if (!isSearchOpen()) return;
    searchSection === null || searchSection === void 0 ? void 0 : searchSection.classList.remove("visible");
    searchBtn === null || searchBtn === void 0 ? void 0 : searchBtn.classList.remove("active");
    if (searchBtn) searchBtn.dataset.open = "false";
  };

  function closeAllSubMenus() {
    document.querySelectorAll(".sub-nav.active").forEach(function (sub) {
      sub.style.visibility = "hidden";
      sub.style.opacity = "0";
      sub.classList.remove("active");
    });
    document.querySelectorAll(".has-sub-nav .site-nav__link").forEach(function (lnk) {
      return lnk.classList.remove("hover-submenu");
    });
  }

  function closeAllBigMenus() {
    document.querySelectorAll(".big-nav.active").forEach(function (big) {
      big.style.visibility = "hidden";
      big.style.opacity = "0";
      big.classList.remove("active");
    });
    document.querySelectorAll(".has-big-nav .site-nav__link").forEach(function (lnk) {
      return lnk.classList.remove("hover-submenu");
    });
  }
  /** True if pointer is on a nav trigger row or inside an open mega/sub panel (desktop). */


  function isInsideDesktopNavUi(target) {
    if (!(target instanceof Element)) return false;
    if (target.closest(".has-big-nav, .has-sub-nav")) return true;
    var panel = document.querySelector(".big-nav.active, .sub-nav.active");
    return !!(panel && panel.contains(target));
  }

  function closeDesktopMegaMenus() {
    closeAllSubMenus();
    closeAllBigMenus();

    if (typeof window.updateHeaderState === "function") {
      window.updateHeaderState();
    }
  }

  function openSubMenu(item) {
    // Ensure search is closed before opening any submenu
    forceCloseSearch();
    var link = item.querySelector(".site-nav__link");
    var subNav = item.querySelector(".sub-nav");
    closeAllBigMenus();
    if (link) link.classList.add("hover-submenu");

    if (subNav) {
      subNav.style.visibility = "visible";
      subNav.style.opacity = "1";
      subNav.classList.add("active");
    }

    header.classList.remove("transparent");
    header.classList.add("white");
    body.classList.add("white-header");
  }

  function openBigMenu(item) {
    // Ensure search is closed before opening any big menu
    forceCloseSearch();
    var link = item.querySelector(".site-nav__link");
    var bigNav = item.querySelector(".big-nav");
    closeAllSubMenus(); // CLOSE sub menu

    if (link) link.classList.add("hover-submenu");

    if (bigNav) {
      bigNav.style.visibility = "visible";
      bigNav.style.opacity = "1";
      bigNav.classList.add("active");
    }

    header.classList.remove("transparent");
    header.classList.add("white");
    body.classList.add("white-header");
  } // ---- Sub menu hover (DESKTOP ONLY) ----


  subItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      // Only run on desktop
      if (window.innerWidth >= 981) {
        openSubMenu(item);
      }
    }); // item.addEventListener("mouseleave", () => closeAllSubMenus());
  }); // ---- Big menu hover (DESKTOP ONLY) ----

  bigItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      // Only run on desktop
      if (window.innerWidth >= 981) {
        openBigMenu(item);
      }
    }); // item.addEventListener("mouseleave", () => closeAllBigMenus());
  }); // ---- CLOSE mega/sub on outside hover (desktop) ----

  document.addEventListener("mousemove", function (e) {
    lastPointerClientX = e.clientX;
    lastPointerClientY = e.clientY;
    hasPointerPosition = true;
    var desktop = window.innerWidth >= 981;
    var outsideNavUi = desktop && !isInsideDesktopNavUi(e.target);

    if (outsideNavUi) {
      closeAllSubMenus();
      closeAllBigMenus();
    } // On pages without hero, header must stay white


    if (!pageHasHero()) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    }

    var mobileNav = document.getElementById("navbarNavDropdown"); // If mobile nav is open, always keep header white (no transparent)

    if (mobileNav && mobileNav.classList.contains("active")) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    } // Keep header white while search is open (or header is fixed)


    var searchOpen = isSearchOpen();

    if (searchOpen) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    }

    if (outsideNavUi && !header.classList.contains("fixed")) {
      header.classList.remove("white");
      body.classList.remove("white-header");
      header.classList.add("transparent");
    }
  }); // Scroll dismisses mega only when the pointer is not over the menu (wheel over page vs over dropdown)

  window.addEventListener("scroll", function () {
    if (window.innerWidth < 981) return;
    if (!document.querySelector(".big-nav.active, .sub-nav.active")) return;
    if (!hasPointerPosition) return;
    var topEl = document.elementFromPoint(lastPointerClientX, lastPointerClientY);
    if (topEl && isInsideDesktopNavUi(topEl)) return;
    closeDesktopMegaMenus();
  }, {
    passive: true
  }); // Click / tap outside nav triggers and open panels (desktop)

  document.addEventListener("click", function (e) {
    if (window.innerWidth < 981) return;
    if (!document.querySelector(".big-nav.active, .sub-nav.active")) return;
    if (isInsideDesktopNavUi(e.target)) return;
    closeDesktopMegaMenus();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || window.innerWidth < 981) return;
    if (!document.querySelector(".big-nav.active, .sub-nav.active")) return;
    closeDesktopMegaMenus();
  });
}); // Search

document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("mainHeader");
  var body = document.body;
  var searchSection = document.getElementById("js-header-search-section");
  var searchBtn = document.getElementById("js__header-search-btn");
  var bigNav = document.querySelector(".big-nav");
  var bigNavTriggers = document.querySelectorAll(".has-big-nav");
  var subNavTriggers = document.querySelectorAll(".has-sub-nav");
  if (!searchSection || !searchBtn) return;
  var searchInput = searchSection.querySelector(".search"); // 🔹 CLOSE ALL MENUS

  function closeAllMenus() {
    if (bigNav !== null && bigNav !== void 0 && bigNav.classList.contains("active")) {
      bigNav.classList.remove("active");
      bigNav.style.visibility = "hidden";
      bigNav.style.opacity = "0";
    }

    document.querySelectorAll(".sub-nav.active").forEach(function (sub) {
      sub.style.visibility = "hidden";
      sub.style.opacity = "0";
      sub.classList.remove("active");
    });
    subNavTriggers.forEach(function (item) {
      item.classList.remove("hover-submenu");
    });
  } // 🔹 APPLY HEADER WHITE


  function applyHeaderWhite() {
    header.classList.add("white");
    header.classList.remove("transparent");
    body.classList.add("white-header");
  } // 🔹 REMOVE HEADER WHITE (BUT RESPECT FIXED RULE & MOBILE NAV)


  function removeHeaderWhite() {
    var mobileNav = document.getElementById("navbarNavDropdown"); // If mobile nav is open, keep header white and do not switch to transparent

    if (mobileNav && mobileNav.classList.contains("active")) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    }

    body.classList.remove("white-header"); // IF FIXED → do NOT add transparent, KEEP white

    if (header.classList.contains("fixed")) {
      header.classList.add("white");
      header.classList.remove("transparent");
      return;
    } // Otherwise allow transparent header


    header.classList.remove("white");
    header.classList.add("transparent");
  } // 🔸 OPEN SEARCH


  function openSearch() {
    closeAllMenus();
    searchSection.classList.add("visible");
    searchBtn.classList.add("active");
    searchBtn.dataset.open = "true";
    applyHeaderWhite();
    searchInput === null || searchInput === void 0 ? void 0 : searchInput.focus();
  } // 🔸 CLOSE SEARCH


  function closeSearch() {
    searchSection.classList.remove("visible");
    searchBtn.classList.remove("active");
    searchBtn.dataset.open = "false";
    var submenuActive = document.querySelector(".has-sub-nav .hover-submenu") || document.querySelector(".sub-nav.active");
    var bigNavActive = document.querySelector(".has-big-nav .hover-submenu") || document.querySelector(".big-nav.active"); // Keep header white if a menu is being hovered/opened

    if (submenuActive || bigNavActive) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    }

    removeHeaderWhite();
  } // Toggle by click


  searchBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    searchBtn.dataset.open === "true" ? closeSearch() : openSearch();
  }); // Close when clicking outside

  document.addEventListener("click", function () {
    if (searchBtn.dataset.open === "true") closeSearch();
  }); // Prevent search from closing when clicking inside

  searchSection.addEventListener("click", function (e) {
    return e.stopPropagation();
  }); // ESC close

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && searchBtn.dataset.open === "true") closeSearch();
  }); // Hovering any submenu auto closes search

  subNavTriggers.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      if (searchBtn.dataset.open === "true") closeSearch();
    });
  }); // Hovering any big menu auto closes search

  bigNavTriggers.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      if (searchBtn.dataset.open === "true") closeSearch();
    });
  });
}); // Open MObile Menu

document.addEventListener("DOMContentLoaded", function () {
  var navLink = false;
  var hamburger = document.getElementById("hamburger");
  var nav = document.getElementById("navbarNavDropdown");
  var header = document.getElementById("mainHeader");
  var hideEls = document.querySelectorAll(".js__mobile-menu-open-hide, .js__mobile-announcement-text"); // ✅ Check if required elements exist before proceeding

  if (!hamburger || !nav || !header) {
    console.warn("Hamburger menu elements not found. Required: #hamburger, #navbarNavDropdown, #mainHeader");
    return;
  } // 🔍 Check if page has hero/inner-banner/error-page


  var hasHero = !!document.querySelector(".hero-banner, .inner-hero-section, .error-page, .collection-hero-section"); // 🧠 Handles header state on scroll & nav open/close
  // var updateHeaderState = function updateHeaderState() {
  //   var scrollY = window.scrollY; // 🧩 Pages without hero → always white, always white-header
  //   if (!hasHero) {
  //     header.classList.add("white");
  //     header.classList.remove("transparent");
  //     document.body.classList.add("white-header");
  //     return;
  //   } // 🧩 Pages with hero → normal behavior
  //   if (nav.classList.contains("active")) {
  //     // 🔹 When mobile menu is open
  //     header.classList.remove("transparent");
  //     header.classList.add("white");
  //     document.body.classList.add("white-header");
  //   } else {
  //     // 🔹 When menu is closed
  //     if (scrollY > 50) {
  //       header.classList.add("fixed", "white");
  //       header.classList.remove("transparent");
  //       document.body.classList.add("white-header");
  //     } else {
  //       document.body.classList.remove("white-header");
  //       header.classList.remove("fixed", "white");
  //       header.classList.add("transparent");
  //     }
  //   }
  // };
  // Use inline header controller if present (prevents collisions)

  var updateHeaderState = typeof window.updateHeaderState === "function" ? window.updateHeaderState : function () {};

  var toggleMenu = function toggleMenu() {
    hamburger.classList.toggle("active");
    nav.classList.toggle("active");
    navLink = true;
    hideEls.forEach(function (el) {
      return nav.classList.contains("active") ? el.classList.add("active") : el.classList.remove("active");
    }); // Lock scroll when open (for mobile)

    if (nav.classList.contains("active")) {
      if (window.innerWidth < 981) {
        document.documentElement.style.overflow = "hidden";
        document.documentElement.classList.add("scroll-stop");
      } else {
        document.documentElement.style.overflowY = "scroll";
        document.documentElement.classList.remove("scroll-stop");
      }
    } else {
      document.documentElement.style.overflowY = "scroll";
      document.documentElement.classList.remove("scroll-stop");
    }

    updateHeaderState();
  };

  hamburger.addEventListener("click", toggleMenu); // hamburger.addEventListener("focus", function () {
  //   if (!navLink) toggleMenu();
  // });

  window.addEventListener("resize", updateHeaderState); // window.addEventListener("scroll", updateHeaderState);

  updateHeaderState();
}); // Dynamic Mobile Nav Bar top according to the height of the header and the announcement

document.addEventListener("DOMContentLoaded", function () {
  var nav = document.getElementById("navbarNavDropdown");
  var header = document.getElementById("mainHeader");
  var announcement = document.querySelector(".announcement-bar");

  function isVisible(el) {
    return el && el.offsetParent !== null && el.offsetHeight > 0;
  }

  function setNavTop() {
    if (!nav || !header) return;
    var baseHeaderHeight = 70;
    var totalHeight = baseHeaderHeight;

    if (!header.classList.contains("fixed")) {
      // Only add announcement height when header is not fixed
      if (window.innerWidth < 981 && isVisible(announcement)) {
        totalHeight += announcement.offsetHeight;
      }
    }

    nav.style.top = "".concat(totalHeight, "px");
  } // Run on load


  setNavTop(); // Run on resize

  window.addEventListener("resize", setNavTop);
});
/** CART SIDEBAR
 * Close on Outside Click
 * **/
// Flag to prevent cart from closing immediately after opening

window.cartJustOpened = false;
window.cartOpenTime = 0;
window.addingFromModal = false;
$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");

  if (!popup.hasClass("active")) {
    return;
  } // CRITICAL: If we're adding from modal, don't close the cart at all


  if (window.addingFromModal) {
    return;
  } // Prevent closing if cart just opened (within 3 seconds for modal add to cart)


  if (window.cartJustOpened && Date.now() - window.cartOpenTime < 3000) {
    return;
  } // Don't close if clicking on modal elements (even if modal is hidden, check the original target)


  var originalTarget = e.originalEvent && e.originalEvent.target ? e.originalEvent.target : e.target;

  if ($(originalTarget).closest(".modal-quick-view").length > 0 || $(originalTarget).closest(".js__modal-popup-addtocart").length > 0 || $(originalTarget).closest(".modal").length > 0 || $(e.target).closest(".modal-quick-view").length > 0 || $(e.target).closest(".js__modal-popup-addtocart").length > 0 || $(e.target).closest(".modal").length > 0) {
    return;
  } // Don't close if the click originated from a modal button


  if (e.originalEvent && e.originalEvent.target) {
    var clickTarget = $(e.originalEvent.target);

    if (clickTarget.hasClass("js__modal-popup-addtocart") || clickTarget.closest(".js__modal-popup-addtocart").length > 0) {
      return;
    }
  } // Close if clicking on the overlay


  if (overlay.is(e.target)) {
    popup.removeClass("active");
    overlay.removeClass("active");
    $(".js__cart-expand").removeClass("active");
    window.cartJustOpened = false;
    return;
  } // Close if clicking outside both cart and overlay


  if (!popup.is(e.target) && popup.has(e.target).length == 0 && !overlay.is(e.target)) {
    popup.removeClass("active");
    overlay.removeClass("active");
    $(".js__cart-expand").removeClass("active");
    window.cartJustOpened = false;
  }
}); // Explicit overlay click handler to close cart

$(document).on("click", "#cart_overlay", function (e) {
  // CRITICAL: If we're adding from modal, don't close the cart at all
  if (window.addingFromModal) {
    return;
  } // Don't close if cart just opened (within 3 seconds for modal add to cart)


  if (window.cartJustOpened && Date.now() - window.cartOpenTime < 3000) {
    return;
  }

  if ($("#CartSidebar").hasClass("active")) {
    $("#CartSidebar").removeClass("active");
    $(this).removeClass("active");
    $(".js__cart-expand").removeClass("active");
    window.cartJustOpened = false;
  }
});
/* OPEN BIG NAV SECTION ON mobile */

(function ($) {
  $(function () {
    var navLink = false;
    var isClosingBigNav = false; // Flag to prevent link click when closing big-nav

    $(".js__big-nav-link").on("click", function (e) {
      // Only run on mobile devices
      if ($(window).width() >= 981) {
        return; // Don't run on desktop
      } // Check global flag first - if sub-nav is being closed, block this


      if (window.isClosingSubNav) {
        console.log("Blocking big-nav-link because sub-nav is closing");
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      } // If we just closed a big-nav, ignore this click


      if (isClosingBigNav) {
        e.preventDefault();
        e.stopPropagation();
        isClosingBigNav = false; // Reset flag

        return false;
      } // IMPORTANT: Check if click originated from sub-nav-close button
      // This prevents big-nav from opening when clicking sub-nav back button


      var $target = $(e.target);

      if ($target.closest(".js__sub-nav-close").length > 0) {
        console.log("Click from sub-nav-close detected in big-nav-link, blocking");
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      } // Check if click originated from back button or big-nav area


      if ($target.closest(".js__big-nav-close").length > 0 || $target.closest(".js__big-nav").length > 0) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      var $parentLi = $(this).closest("li");
      var $bigNav = $parentLi.find(".js__big-nav"); // Don't open if big-nav is already active

      if ($bigNav.hasClass("active")) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      $(this).toggleClass("active");
      $bigNav.toggleClass("active");
      $parentLi.toggleClass("big-nav-open"); // Add class to parent for CSS targeting

      navLink = true;
    }).focus(function () {
      "use strict";

      if (!navLink) {
        var $parentLi = $(this).closest("li");
        var $bigNav = $parentLi.find(".js__big-nav");
        $(this).toggleClass("active");
        $bigNav.toggleClass("active");
        $parentLi.toggleClass("big-nav-open");
      }
    }); // Store reference to big nav handler for use in close handler

    window.bigNavLinkHandler = {
      setClosingFlag: function setClosingFlag() {
        isClosingBigNav = true; // Reset flag after a short delay

        setTimeout(function () {
          isClosingBigNav = false;
        }, 300);
      }
    };
  });
})(jQuery);
/* OPEN SUB NAV SECTION ON MOBILE */


(function ($) {
  $(function () {
    var navLink = false;
    var isClosingSubNav = false; // Flag to prevent link click when closing sub-nav
    // Handle click event - MOBILE ONLY

    $(document).on("click", ".js__sub-nav-link", function (e) {
      // Only run on mobile devices
      if ($(window).width() >= 981) {
        return; // Don't run on desktop
      } // Only block if click is specifically on the back button


      var $target = $(e.target);

      if ($target.closest(".js__sub-nav-close").length > 0) {
        console.log("Click on back button, blocking");
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      var $parentLi = $(this).closest("li");
      var $subNav = $parentLi.find(".js__sub-nav");
      var $link = $(this); // Don't open if sub-nav is already active (prevent toggle when clicking link while sub-nav is open)

      if ($subNav.hasClass("active")) {
        console.log("Sub-nav already active, blocking");
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      isClosingSubNav = false; // Add active class to link and open sub-nav
      // Force add the class using native JS to ensure it's added

      $link[0].classList.add("active");
      $subNav[0].classList.add("active");
      $parentLi[0].classList.add("sub-nav-open"); // Also use jQuery as backup

      $link.addClass("active");
      $subNav.addClass("active");
      $parentLi.addClass("sub-nav-open");
      navLink = true;
    }); // Focus handler

    $(document).on("focus", ".js__sub-nav-link", function (e) {
      "use strict";

      if (navLink) {} else {
        var $parentLi = $(this).closest("li");
        var $subNav = $parentLi.find(".js__sub-nav");
        $(this).toggleClass("active");
        $subNav.toggleClass("active");
        $parentLi.toggleClass("sub-nav-open");
      }
    }); // Store reference to link handler for use in close handler

    window.subNavLinkHandler = {
      setClosingFlag: function setClosingFlag() {
        isClosingSubNav = true;
        console.log("Closing flag set"); // Reset flag after a short delay to allow click event to complete

        setTimeout(function () {
          isClosingSubNav = false;
          console.log("Closing flag reset");
        }, 100); // Reduced delay
      },
      resetFlag: function resetFlag() {
        isClosingSubNav = false;
        console.log("Closing flag manually reset");
      }
    };
  });
})(jQuery); // Close MOBILE SUB NAV ON CLICK BACK


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__sub-nav-close").on("click", function (e) {
      console.log("Sub-nav-close click fired"); // CRITICAL: Stop ALL event propagation FIRST before doing anything

      e.stopPropagation(); // Prevent event bubbling to parent elements

      e.preventDefault(); // Prevent default behavior

      e.stopImmediatePropagation(); // Stop all other handlers on this element
      // Set a global flag to prevent any nav link handlers from firing

      window.isClosingSubNav = true; // Set flag to prevent link handler from firing

      if (window.subNavLinkHandler && window.subNavLinkHandler.setClosingFlag) {
        window.subNavLinkHandler.setClosingFlag();
      } // Find the specific sub-nav related to this close button


      var $subNav = $(this).closest(".js__sub-nav");
      var $parentLi = $(this).closest("li");
      var $navLink = $parentLi.find(".js__sub-nav-link"); // IMPORTANT: Add a temporary overlay to block clicks during closing

      var $overlay = $('<div class="sub-nav-close-overlay" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9998; pointer-events: all; background: transparent;"></div>');
      $("body").append($overlay); // Close the sub-nav with a slight delay to ensure overlay is in place

      setTimeout(function () {
        $subNav.removeClass("active");
        $navLink.removeClass("active");
        $parentLi.removeClass("sub-nav-open"); // Remove overlay after a delay

        setTimeout(function () {
          $overlay.remove();
          window.isClosingSubNav = false;

          if (window.subNavLinkHandler && window.subNavLinkHandler.resetFlag) {
            window.subNavLinkHandler.resetFlag();
          }
        }, 300);
      }, 10);
      navLink = true; // Prevent click from reaching elements below by blocking the event completely

      return false;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        var $subNav = $(this).closest(".js__sub-nav");
        var $parentLi = $(this).closest("li");
        var $navLink = $parentLi.find(".js__sub-nav-link");
        $subNav.removeClass("active");
        $navLink.removeClass("active");
        $parentLi.removeClass("sub-nav-open");
      }
    });
  });
})(jQuery); // Open Search in mobile


(function ($) {
  $(document).ready(function () {
    var navLink = false;

    function isMobileSearchOpen() {
      return $("#js-header-search-block").hasClass("active");
    }

    function openMobileSearch() {
      $("#js__mobile-search").addClass("active");
      $("#js-header-search-block").addClass("active");
      $(".js__search-mobile-close").addClass("active");
    }

    function closeMobileSearch() {
      $("#js__mobile-search").removeClass("active");
      $("#js-header-search-block").removeClass("active");
      $(".js__search-mobile-close").removeClass("active");
    } // Open Mobile Search (icon)


    $("#js__mobile-search").on("click", function (e) {
      e.preventDefault();

      if (!isMobileSearchOpen()) {
        openMobileSearch();
      }

      navLink = true;
    }).on("focus", function () {
      if (!navLink && !isMobileSearchOpen()) {
        openMobileSearch();
      }
    });
    $(".js__search-mobile-close").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (isMobileSearchOpen()) {
        closeMobileSearch();
      }

      navLink = true;
    }).on("focus", function () {
      if (!navLink && isMobileSearchOpen()) {
        closeMobileSearch();
      }
    });
  });
})(jQuery); // Close MOBILE SUB NAV ON CLICK BACK


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__big-nav-close").on("click", function (e) {
      e.stopPropagation(); // Prevent event bubbling to parent elements

      e.preventDefault(); // Prevent default behavior

      e.stopImmediatePropagation(); // Stop all other handlers
      // Set flag to prevent link handler from firing

      if (window.bigNavLinkHandler && window.bigNavLinkHandler.setClosingFlag) {
        window.bigNavLinkHandler.setClosingFlag();
      } // Find the specific big-nav related to this close button


      var $bigNav = $(this).closest(".js__big-nav");
      var $parentLi = $(this).closest("li");
      var $navLink = $parentLi.find(".js__big-nav-link"); // Close the big-nav

      $bigNav.removeClass("active");
      $navLink.removeClass("active");
      $parentLi.removeClass("big-nav-open"); // Remove class from parent

      navLink = true;
      return false;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        var $bigNav = $(this).closest(".js__big-nav");
        var $parentLi = $(this).closest("li");
        var $navLink = $parentLi.find(".js__big-nav-link");
        $bigNav.removeClass("active");
        $navLink.removeClass("active");
        $parentLi.removeClass("big-nav-open");
      }
    });
  });
})(jQuery); // Mobile Sub menu Menu Accordion


(function ($) {
  $(function () {
    var navLink = false;
    $(".accordion-toggle-inner").on("click", function (e) {
      "use strict";

      e.stopImmediatePropagation();

      if ($(window).width() < 981) {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".accordion-content-inner").slideUp(300);
        } else {
          $(".accordion-toggle-inner").removeClass("active");
          $(this).addClass("active");
          $(".accordion-content-inner").slideUp(300);
          $(this).siblings(".accordion-content-inner").slideDown(300);
        }
      }

      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {
        navLink = false;
      } else {
        if ($(window).width() < 981) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }

        if ($(window).width() < 980) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }
      }
    });
  });
})(jQuery);
"use strict";

var pdpThumbnail;
var pdpSlider;
$(document).ready(function ($) {
  var producrSlider = new Swiper(".js__pdp-recommendation-slider", {
    slidesPerView: 3,
    autoHeight: true,
    resistance: false,
    shortSwipes: true,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next-product-recommed",
      prevEl: ".swiper-button-prev-product-recommed"
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      601: {
        slidesPerView: 2
      },
      981: {
        slidesPerView: 3
      }
    }
  });
  /*Slider working Start*/

  if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      slidesPerView: 3,
      resistance: false,
      shortSwipes: false,
      clickable: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      draggable: true,
      breakpoints: {
        980: {
          slidesPerView: "auto",
          direction: "horizontal"
        },
        981: {
          slidesPerView: 6,
          direction: "vertical"
        }
      }
    });
  } else {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      resistance: false,
      shortSwipes: true,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      clickable: true,
      grabCursor: true,
      mousewheel: true,
      direction: "horizontal",
      spaceBetween: 20,
      breakpoints: {
        // when window width is >= 320px
        0: {
          slidesPerView: 2
        },
        360: {
          slidesPerView: 2
        },
        // when window width is >= 480px
        401: {
          slidesPerView: 3
        },
        // when window width is >= 640px
        601: {
          slidesPerView: 4
        }
      }
    });
  }

  pdpSlider = new Swiper(".js__pdp-slider", {
    slidesPerView: 1,
    grabCursor: false,
    mousewheel: false,
    clickable: false,
    resistance: false,
    shortSwipes: true,
    spaceBetween: 12,
    loop: false,
    pagination: {
      el: ".swiper-pagination-pdp",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next-pdp",
      prevEl: ".swiper-button-prev-pdp"
    },
    thumbs: {
      swiper: pdpThumbnail
    }
  });
  /*PDP tab section drop down change*/

  $(".js__pdp-tab-select").change(function () {
    $(".tab-content").removeClass("active");
    $(".tab-content").hide();
    $("#" + $(this).val()).show();
    $("#" + $(this).val()).addClass("active");
    $(".tab-link").removeClass("active");
    $("#tab-link-" + $(this).val()).addClass("active");
  });
  /* var pdpSlideCount = 0;
         $(document).on("click", ".swiper-button-next-pdp.swiper-button-disabled", function(e) {
                 var ariaLabel = $(".js__pdp-slider").find(".swiper-slide-active").attr("aria-label").split("/");
                 console.log(ariaLabel[0]);
                 console.log(ariaLabel[1]);
                 pdpSlideCount++;
                 if (pdpSlideCount == 2) {
                     if (ariaLabel[0].trim() == ariaLabel[1].trim()) {
                         pdpSlideCount = 0
                         pdpSlider.slideTo(0);
                     }
                 }
              })*/

  /* Manual click of thumbnail of slider*/

  $(document).on("click", ".pdp-thumbnail li", function (e) {
    var slideno = $(this).index();
    $(".pdp-thumbnail li").removeClass("active");
    $(this).addClass("active");
    $(".pdp-slider").slick("slickGoTo", slideno);
    setTimeout(function () {
      $(".pdp-thumbnail").slick("slickGoTo", slideno);
    }, 500);
    /* var slideno = $(this).index();
                     $(".pdp-thumbnail li").removeClass("active");
                     $(this).addClass("active");
                     console.log("slideno"+slideno);
               
                     $(".pdp-slider").slick("slickGoTo", slideno);*/
  });
  /*Write review click*/

  $(".js__write-review-btn").click(function () {
    $(".yotpo-new-review-btn").click();
  });
  /*View details*/

  $(document).on("click", ".js__pdp-view-details", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $(".tab-head li:first-child").children(".tab-link").addClass("active");
    $(".tab-content").removeClass("active");
    $(".tab-content:first-child").addClass("active");
    $(".tab-content").hide();
    $(".tab-content:first-child").show();
    $(".js__pdp-tab-select").val($(".tab-head li:first-child").children(".tab-link").attr("data-attr"));
    setTimeout(function () {
      var target = $(".tab-content:first-child");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });
  /*Review star click*/

  $(document).on("click", ".js__review-section", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $("#tab-link-reviews").addClass("active");
    $(".tab-content").removeClass("active");
    $("#reviews").addClass("active");
    $(".tab-content").hide();
    $("#reviews").show();
    $(".js__pdp-tab-select").val("Reviews");
    setTimeout(function () {
      var target = $("#reviews");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  }); //         $(document).on("click", ".appstle_one_time_details_wrapper input", function () {
  //     console.log("clicked");
  //     var amount = $(".appstle_one_time_details_wrapper").find(".appstle_subscription_amount").html();
  // $(".js__product-single__prices").children("span").html(amount);
  // })
  // $(document).on("click", ".appstle_subscription_radio_wrapper input", function () {
  //     console.log("clicked");
  //        var amount = $(".appstle_subscription_radio_wrapper").find(".appstle_subscription_amount").html();
  // $(".js__product-single__prices").children("span").html(amount);
  // })

  /*Ninja price update */

  var targetNodes = $(".product__form");
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  var bundleObersrver = new MutationObserver(mutationHandler);
  var obsConfig = {
    childList: true,
    characterData: true,
    attributes: true,
    subtree: true
  }; //--- Add a target node to the observer. Can only add one node at a time.
  // Hide the main PDP price when the Appstle subscription widget is present/visible

  function toggleMainPriceForSubscription() {
    var $mainPriceWrapper = $(".js__pdp-main-price");
    if (!$mainPriceWrapper.length) return; // If any Appstle subscription wrapper exists and is visible, hide the main price

    if ($(".appstle_subscription_wrapper:visible").length) {
      $mainPriceWrapper.addClass("hide");
    } else {
      $mainPriceWrapper.removeClass("hide");
    }
  }

  targetNodes.each(function () {
    bundleObersrver.observe(this, obsConfig);
  });

  function mutationHandler(mutationRecords) {
    //loop through all the mutations that just occured
    mutationRecords.forEach(function (mutation) {
      if (mutation.type == "childList" || mutation.type == "attributes") {
        // Whenever children/attributes change under product form, re-evaluate subscription visibility
        toggleMainPriceForSubscription(); //loop though the added nodes

        mutation.addedNodes.forEach(function (added_node) {
          // console.log($(".rc-container-wrapper").html())
          if ($(".rc-container-wrapper").html() != undefined) {
            bundleObersrver.disconnect();
          }

          setTimeout(function () {}, 500);
        });
      }
    });
  } // Initial check in case Appstle widget is already on the page


  setTimeout(function () {
    toggleMainPriceForSubscription();
  }, 500);
  /*Slider working End*/

  /* Call page load functions */

  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */

  function setColorThumbImages() {
    if ($(".js-variant-color-swatch li")[0]) {
      $(".js-variant-color-swatch  li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color); //$(this).children("div.color").css("background-color", colorValue);

        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }

        $(this).children("img").attr("src", colorValue);
      });
    }
  }
});
/*PENDING Get Variant Color*/

function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
               if (color.toLowerCase() == value.option1.toLowerCase()) {
                 variantColorValue = value.image;
               }
             });*/

    return variantColorValue;
  } catch (_unused) {}
}
/* Color swatch click*/


$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var variantImage = $(this).attr("data-image");
    var featuredImage = $(this).attr("data-featured_image");

    if (variantImage.indexOf("no-image-") == -1) {
      $(".js__product-image-" + productID).attr("src", variantImage);
    } else {
      $(".js__product-image-" + productID).attr("src", featuredImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
  $(document).on("click", ".appstle_subscription_radio_wrapper input", function () {
    $(".hulkapps-volumes").hide();
  });
  $(document).on("click", ".appstle_one_time_details_wrapper input", function () {
    $(".hulkapps-volumes").show();
  }); // Strong override: intercept clicks on offer-option-btn at capture phase
  // and add the offer items to the Shopify cart.

  document.addEventListener("click", function (event) {
    var btn = event.target.closest(".offer-option-btn");
    if (!btn) return;
    event.preventDefault();

    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    event.stopPropagation();
    var container = btn.closest(".offer-options-list");
    if (!container) return;
    var items = [];
    $(container).find(".offer-option-item").each(function () {
      var addAttr = this.getAttribute("data-add");
      if (!addAttr) return;

      try {
        var data = JSON.parse(addAttr);

        if (data && data.variant_id) {
          var qty = parseInt(data.quantity, 10);
          if (isNaN(qty) || qty <= 0) qty = 1;
          items.push({
            id: data.variant_id,
            quantity: qty
          });
        }
      } catch (e) {// ignore bad JSON
      }
    });

    if (!items.length) {
      console.warn("No items found to add to cart from offer-options-list.");
      return;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: JSON.stringify({
        items: items
      }),
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      success: function success(response) {
        // For "Buy it Now" button, go straight to checkout
        if (btn.classList.contains("buynow")) {
          window.location.href = "/checkout";
        } else {
          if (typeof getglobalLib === 'function' && getglobalLib('Mini_Cart') == 'yes') {
            jQuery.getJSON('/cart.js', function (cart) {
              if (typeof showCartSuccessMessage === 'function') showCartSuccessMessage();
              if (typeof reloadAjaxCartItemUsingCartAjaxObject === 'function') reloadAjaxCartItemUsingCartAjaxObject(cart);
            });
          } else {
            window.location = '/cart';
          }
        }
      },
      error: function error(xhr, status, _error) {
        console.error("Error adding offer items to cart", status, _error);
      }
    });
  }, true);
});
"use strict";

var colorSelected = "";
var secondOptionVariantValue = "";
var thirdOptionVariantValue = "";
var selectedVariantID;
$(document).ready(function ($) {
  /* if no varient then active class added in product image section*/
  if (prodLib.length == 0) {
    $(".js-pdp-media").addClass("active");
    $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
  }

  var colorPosition = $("#colorPosition").val();
  var numberOfAvailableOptions = parseInt($("#optionSize").val()); // on page load check the color position, and set 2nd and 3rd options values

  checkColorPosition();

  function checkColorPosition() {
    getColorPosition();
    /* 
    if only color and no other options
    */

    if (colorPosition != undefined && numberOfAvailableOptions == 1) {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    }
  }
  /*Quantity Plus Minus*/


  $(".js-product-single__quantity .js-plus-minus-qty").click(function () {
    var type = $(this).attr("data-type");
    var productQuantity = $(".js-quantity-selector").val();

    if (type == "minus") {
      if (productQuantity > 1) {
        productQuantity--;
      }
    } else {
      productQuantity++;
    }

    $(".js-quantity-selector").val(productQuantity);
  }); // On DD change, fire the form DD element and also run the soldoutColorSwatches function

  $(".js__pdp-variant-select").change(function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).val();
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue); // button  - Sold out and add to cart

    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).attr("data-type");
    var FilterType = $("#variantFilterType").val();

    if (OptionType == FilterType) {
      imageFilter(optionValue);
    }

    var selectedVariant = $("#product-select :selected").text().replace("- sold out!", "");
    $(".js__product-variant-selected").html(selectedVariant);
    $(".rc-option--active").click(); //color swatch - sold out working

    SoldOutUnavailableOnColorSwatches(colorSelected);
  });
  $(document).on("click", ".js__pdp-variant-select li", function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).attr("data-value");
    var optionType = $(this).parent("ul").attr("data-type");
    $(this).parent("ul").children("li").removeClass("active");
    $(this).addClass("active");
    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    $("#product-select").change();
    /*Checking if this is filter type then image filter code will work*/

    try {
      var FilterType = $("#variantFilterType").val();

      if (optionType == FilterType) {
        imageFilter(optionValue);
      }
    } catch (_unused) {} // button  - Sold out and add to cart


    try {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    } catch (_unused2) {} //color swatch - sold out working

  });
  $(".js__pdp-variant-select li.active").click();
  $(".js__color-swatches").click(function () {
    // remove active class - from all the li's
    $(".js__color-swatches").removeClass("active"); // add class on the one which is clicked

    $(this).addClass("active");
    var optionindex = $(this).data("option");
    var thevalue = $(this).data("value"); //show the selected value

    $(".variant-option.option-" + optionindex + " .label span").text(thevalue); // trigger change

    $("#product-select-option-" + optionindex).val(thevalue).trigger("change");
    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).parent("ul").attr("data-type");
    var FilterType = $("#variantFilterType").val();

    if (OptionType == FilterType) {
      imageFilter(thevalue);
    }
  });
  /*Run this function when image change on variant click*/

  function imageFilter(selectedValue) {
    /*Slick slider filter on swatch click*/
    var thumbColorSelected = selectedValue.replace(" ", "-");
    thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
    thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/---/g, "-"); // $(".pdp-slider").slick("slickUnfilter");
    //   $(".js__pdp-thumbnail-slider").slick("slickUnfilter");

    $(".pdp-slider").find(".all").addClass(thumbColorSelected.toLowerCase());
    $(".js__pdp-thumbnail-slider").find(".all").addClass(thumbColorSelected.toLowerCase()); //   $(".pdp-slider").slick("slickFilter", "." + thumbColorSelected.toLowerCase());
    //  $(".js__pdp-thumbnail-slider").slick( "slickFilter","." + thumbColorSelected.toLowerCase());

    $(".js__pdp-thumbnail-slider .swiper-slide").removeClass("active"); //$(".js__pdp-thumbnail-slider").slick("refresh");

    $(".pdp-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".js__pdp-thumbnail-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".pdp-slider").find(".slide").children(".image-section").removeAttr("data-fancybox");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".js__pdp-thumbnail-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).children(".image-section").attr("data-fancybox", "product");
    pdpThumbnail.destroy();
    pdpSlider.destroy();

    if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        slidesPerView: 3,
        resistance: false,
        shortSwipes: false,
        freeMode: true,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: true,
        observer: true,
        observeParents: true,
        draggable: true
      });
    } else {
      pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
        resistance: false,
        shortSwipes: true,
        loop: true,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesProgress: true,
        clickable: true,
        grabCursor: true,
        mousewheel: true,
        spaceBetween: 20,
        breakpoints: {
          // when window width is >= 320px
          360: {
            slidesPerView: 2
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 3
          },
          // when window width is >= 640px
          601: {
            slidesPerView: "auto"
          }
        }
      });
    }

    pdpSlider = new Swiper(".js__pdp-slider", {
      slidesPerView: 1,
      grabCursor: false,
      mousewheel: false,
      clickable: false,
      resistance: false,
      shortSwipes: true,
      loop: false,
      spaceBetween: 12,
      pagination: {
        el: ".swiper-pagination-pdp",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next-pdp",
        prevEl: ".swiper-button-prev-pdp"
      },
      thumbs: {
        swiper: pdpThumbnail
      }
    });
    /*Selected first variant image in slider which have no all class*/

    var boolVariantFirstImage = false;
    $(".js__pdp-thumbnail-slider  li").each(function () {
      if (!$(this).hasClass("all")) {
        if (boolVariantFirstImage == false) {
          $(this).click();
          $(this).addClass("active");
          boolVariantFirstImage = true;
        }
      }
    });
    /*When we dont have any variant image*/

    if (boolVariantFirstImage == false) {
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").click();
    }

    colorSelected = selectedValue;
  } // main sold out and unavailable working


  function SoldOutUnavailableOnColorSwatches(colorSelected) {
    getColorPosition(); // Remove out of stock and unavailable from color swatches

    $(".js__color-swatches").removeClass("out-of-stock");
    $(".js__color-swatches").removeClass("unavailable");
    var colorLength = $(".js__color-swatches").length;
    var colorCount = 1;
    /*
        Loop Through each input radio for the color
        */
    // we are using color swatch working for other options when they are radio buttons

    $(".js__color-swatches").each(function (index) {
      var colorValue = $(this).attr("data-value");
      var checkColorOptionExists = false;
      /* 
             Loop through product library object for variant 
             and if variant select matches and quantity = 0 then show out of stock message
             */

      /*
            PENDING - Merge - ProdLib Each Function
            */

      $.each(prodLib, function (key, value) {
        var itemQuantity = value.quantity;
        var itemAvailable = value.available;
        var prodColorOptionValue = "";
        var prodSecondOptionValue = "";
        var prodThirdOptionValue = "";

        if (colorPosition == "1") {
          prodColorOptionValue = value.option1;
          prodSecondOptionValue = value.option2;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "2") {
          prodColorOptionValue = value.option2;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "3") {
          prodColorOptionValue = value.option3;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option2;
        }

        var colorOption = prodColorOptionValue.toLowerCase();
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        /*Checking each color  size quantity and which have 0 then added out of stock class*/

        if (numberOfAvailableOptions == 3) {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == prodSecondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == prodThirdOptionValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else if (numberOfAvailableOptions == 2) {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else {
          //check if quantity>1 then set the color swatch - Out of stock
          setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
        }

        if (prodColorOptionValue == colorValue) {
          if (numberOfAvailableOptions == 3) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && prodThirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else if (numberOfAvailableOptions == 2) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else {
            checkColorOptionExists = true;
          }
        }
      });

      if (checkColorOptionExists == false) {
        var colorOption = colorValue;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        colorOption = colorOption.toLowerCase();
        $(".js__color-swatches[data-type-value=" + colorOption + "]").removeClass("out-of-stock");
        $(".js__color-swatches[data-type-value=" + colorOption + "]").addClass("unavailable");

        if ($(".js__color-swatches[data-type-value=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;

          if (colorCount < colorLength) {
            $(".js__color-swatches:nth-child(" + nextColor + ")").click();
          } else {
            $(".js__color-swatches:nth-child(1)").click();
          }
        }
      }

      colorCount++;
    });
  }

  function getColorPosition() {
    if (colorPosition != undefined && numberOfAvailableOptions > 1) {
      if (colorPosition == "1") {
        secondOptionVariantValue = $(".js__pdp-variant-select1").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }

      if (colorPosition == "2") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }

      if (colorPosition == "3") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
        }
      }
    } else {
      secondOptionVariantValue = $(".js__pdp-variant-select0").val();

      if (numberOfAvailableOptions > 1) {
        thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
      }
    }

    try {
      colorSelected = colorSelected.toLowerCase();
    } catch (_unused3) {}
  }

  function setColorSwatchOutofStock(prodColor, prodQuantity, prodAvailability) {
    if (prodQuantity < 1 && prodAvailability == "false") {
      $(".js__color-swatches[data-type-value=" + prodColor + "]").addClass("out-of-stock");
    }
  }

  $(window).scroll(function () {
    var sticky = $(".product__media-outer"),
        scroll = $(window).scrollTop();
    var pos = sticky.height();

    if (scroll >= 768 & scroll <= pos - 690) {
      sticky.addClass("fixed"); // $(".main-content").addClass("active");
    } else {
      sticky.removeClass("fixed"); // $(".main-content").removeClass("active");
    }
  }); // show para on click read More button

  $(".js__read-more_btn").click(function () {
    $(".js__read-less-content").addClass("hide");
    $(".js__read-more-content").removeClass("hide");
  });
  $(".js__read-less_btn").click(function () {
    $(".js__read-less-content").removeClass("hide");
    $(".js__read-more-content").addClass("hide");
  });
});